$(document).ready(function(){
  var video = $('.rich-video-inner video').get(0);
  var $btn = $('#play-pause-btn');
  var $iconPlay = $btn.find('.icon-play');
  var $iconPause = $btn.find('.icon-pause');

  $btn.click(function() {
  
    if (video.paused) {
      video.play();
      $iconPlay.hide();
      $iconPause.show();
    } else {
      video.pause();
      $iconPause.hide();
      $iconPlay.show();
    }
  });

  // Keep icons in sync if user uses video controls directly
  $(video).on('play pause', function() {
    if (video.paused) {
      $iconPause.hide();
      $iconPlay.show();
    } else {
      $iconPlay.hide();
      $iconPause.show();
    }
  });
  setTimeout(() => {

    let swymData;
    try {
      swymData = JSON.parse(localStorage.getItem('swym-products') || '{}');
    } catch (e) {
      console.error('Invalid JSON in swym-products', e);
      return;
    }

    // Access the 'all' array
    const products = swymData.all;

    if (!Array.isArray(products) || products.length === 0) {
      // Append the text when localStorage is empty
      $('.product-list').append(
        `<li class="empty-cart-message">View your bag items and checkout.</li>`
      );
      return; // Stop further execution if there's no data
    }

    // Limit to the first 4 products
    const firstFourProducts = products.slice(0, 4);

    // Append each of the first four products
    $.each(firstFourProducts, function (index, product) {
      if (product.iu) {
        $('.product-list').append(
          `<li class="va-t account-wishlist-image ga_li" data-action="Wishlist" data-label="${product.bt}" data-link="${product.du}">
            <img src="${product.iu}" width="50" class="img-responsive" alt="${product.vi || 'Product Image'}">
          </li>`
        );
      }
    });


// Wishlist Page Code START
  var $userSpan = $('.swym-user-text.swym-value.swym-value-1');

  // Create the full message with only "Sign in" and "Create an Account" as links
  var messageHtml = `
    <p class="wishlist-message">
      Want to save your wish list? 
      <a href="/account/login" target="_blank">Sign in</a> or 
      <a href="/account/register" target="_blank">Create an Account</a> 
      to view your saved favorites across all your devices.
    </p>
  `;

  // Wrap the span in a div
  $userSpan.wrap('<div class="custom-wrapper"></div>');

  // Insert the message above the span
  $userSpan.before(messageHtml);
// Wishlist Code END

    
// On Certificate Get Metal Value Using Url START
 var urlParams = new URLSearchParams(window.location.search);
    var metalValue = urlParams.get("metal");
    if (metalValue) {
        console.log("Metal Certificate:", metalValue);
      $(".certificate_metal_value").html(metalValue);
        
    }
// On Certificate Get Metal Value Using Url END


    var reviews_length = parseInt($(".total-reviews-search").attr("total-reviews-search"), 10);
if (reviews_length == 0) {
    $(".review-cstm-sct").hide();
}
}, 1000); 


  // add class while scroll the section in collection page
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 10) {
      $('.product-grid-container').addClass('scrolled');
    } else {
      $('.product-grid-container').removeClass('scrolled');
    }
  });
  
 $('.page-t2-gemstone aside,.page-t2-studs aside').css('display','block'); 
  if ($(window).width() > 992) {  
   
    $('.open_desk').addClass('is-open');
   }

  $('body').on('click','.inner_facets_gemstone input',function (e) {

    
    var $this = $(this);

    $('.inner_facets_gemstone li.list-menu__item.facets__item input').removeAttr('checked','checked');


    
        $('#gemcheckbox1, #gemcheckbox').change(function() {
            if($(this).is(':checked')) {
 
    var gteThisval = $this.val();

     var getUrl = window.location.href;
     
    if(gteThisval == "Natural"){
       if((getUrl).includes('?')){
          if((getUrl).includes('?sw=s')){
           getUrl = getUrl.replace('?sw=s','');
          }
          if((getUrl).includes('?filter.p.m.custom.gemstone_accentstone=')){
           getUrl = getUrl.replace('?filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78225571976&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122549384&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456','');
         } else{
           getUrl = getUrl.replace('&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78225571976&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122549384&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456','');  
         }
          window.location.href = getUrl+'?filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122418312&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78221148296';
      }else
      {
        getUrl = getUrl.replace('?filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122549384&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78225571976','');
        window.location.href = getUrl+'?filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122418312&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78221148296';
      }
     }else{
        if((getUrl).includes('?')){
         if((getUrl).includes('?sw=s')){
           getUrl = getUrl.replace('?sw=s','');
          }
         
          if((getUrl).includes('?filter.p.m.custom.gemstone_accentstone=')){
         
            getUrl = getUrl.replace('?filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122418312&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78221148296','');
         } else{
            
          getUrl = getUrl.replace('&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122418312&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78221148296','');
         }
         if((getUrl).includes('?')){
         window.location.href = getUrl+'&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78225571976&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122549384&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456';

         } else{
       window.location.href = getUrl+'?filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78225571976&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122549384&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456';
     
         }  
          
         // getUrl = getUrl.replace('?filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122418312&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78221148296','');
               }else
      {
       
        getUrl = getUrl.replace('?filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122418312&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78221148296','');
         window.location.href = getUrl+'?filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78225571976&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122549384&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456';
      }
    
    }
   localStorage.setItem('inputval', gteThisval);

// $(`li.list-menu__item.facets__item input[value= '${gteSplit}']`).attr('checked','checked');
} else {
             
 
                let parameterName = 'filter.p.m.custom.gemstone_accentstone';
                let url = window.location.href;
              
               let urlParts = url.split('?');
              
                if (urlParts.length >= 2) {
                 
                    let baseUrl = urlParts[0];
                    let queryString = urlParts[1];
                    let params = queryString.split('&');
                  
                    // Filter out the parameter we want to remove
                    params = params.filter(param => !param.startsWith(parameterName + '='));
               
                    // Reconstruct the URL
                    url = baseUrl + (params.length > 0 ? '?' + params.join('&') : '');
                 window.location.href = url;
                }
              
             }
        });

    })
  setTimeout(function(){ 
  var getSelectedinput = $('.inner_facets_gemstone li.list-menu__item.facets__item input:checked').val();

  if (getSelectedinput && getSelectedinput.includes('+')) {
    // Replace all occurrences of '+' with spaces
    getSelectedinput = getSelectedinput.replace(/\+/g, ' ');
} else{
  getSelectedinput = getSelectedinput;
}
var count=0;
$('.custom_button_text_active.gemstone_accentstone_active').each(function () {
   var gteSelectedtext = $(this).text().trim();
    
    if(getSelectedinput == gteSelectedtext){
        if(count == 0 ){
      $(this).parents('facet-remove').show();
        count = 1;
        } else{
       $(this).parents('facet-remove').hide();
        }    
        }else{
        
$(this).parents('facet-remove').hide();
    }
});
},100);  
  $('body').on('click','.gemstone_accentstone_remove',function (e) {
    
    e.preventDefault();
//       var getSelectedinput = $('.inner_facets_gemstone li.list-menu__item.facets__item input:checked').val();

//   if (getSelectedinput && getSelectedinput.includes('+')) {
//     // Replace all occurrences of '+' with spaces
//     getSelectedinput = getSelectedinput.replace(/\+/g, ' ');
// } else{
//   getSelectedinput = getSelectedinput;
// }


                let parameterName = 'filter.p.m.custom.gemstone_accentstone';
                let url = window.location.href;
              
               let urlParts = url.split('?');
              
                if (urlParts.length >= 2) {
                 
                    let baseUrl = urlParts[0];
                    let queryString = urlParts[1];
                    let params = queryString.split('&');
                  
                    // Filter out the parameter we want to remove
                    params = params.filter(param => !param.startsWith(parameterName + '='));
               
                    // Reconstruct the URL
                    url = baseUrl + (params.length > 0 ? '?' + params.join('&') : '');
                 window.location.href = url;
                }


    
    // if(getSelectedinput == "Natural"){
    //   if((getUrl).includes('?filter.p.m.custom.gemstone_accentstone=')){
    //      var getHrefLink = $(this).attr('href').replace('?filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78221148296','');
    //   } else{
    //        var getHrefLink = $(this).attr('href').replace('&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78221148296','');
    //   }  
    // } else{
    //   if((getUrl).includes('?filter.p.m.custom.gemstone_accentstone=')){
    //    var getHrefLink = $(this).attr('href').replace('?filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78225571976&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456','');
    //   } else{
    //  var getHrefLink = $(this).attr('href').replace('&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78225571976&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456','');
    //   }  
      
    // }
  
    window.location.href = getHrefLink;

    
})
let inputval = localStorage.getItem('inputval');
  var getUrl = window.location.href;
  if((getUrl).includes('filter.p.m.custom.gemstone_accentstone')){
  $(`li.list-menu__item.facets__item input[value= '${inputval}']`).attr('checked','checked');
  }
$('.menu-hijo').click(function(){
let Product_Added = localStorage.getItem('Product_Added');
    if(Product_Added != null){
    localStorage.removeItem('Product_Added');
    localStorage.removeItem('wizardInfo_gemstone');
    localStorage.removeItem('wizardInfo');
    localStorage.removeItem('wizardInfo_dyop');
    
    }
})
  $.ajax({
    url: "https://ipinfo.io/json",
    type: 'GET',
    success: function(res) {
      if(res.country == 'USA' || res.country == 'US'){
         $('.estimate_shipping_text,.estimate_shipping').text('Delivery')
         $('#popup_sooner').css('display','block');
         $('#special_ocassion_collection').css('opacity','1');
         $('.sp_end_us').css('display','block');
         $('.tagnewspecial').css('opacity','1');
         $('.jtpl_col_count_cstm').removeClass('cstm_opacity');
         $('#quick_view_collection').css('visibility','visible'); 
          localStorage.setItem('countryus', 'yes'); 
         $('.col_card_gift_svg').css('display','block');
       } else{
         $('.estimate_shipping_text,.estimate_shipping').text('Shipping')
         $('#popup_sooner').css('display','none');
         $('#special_ocassion_collection').css('opacity','0');
         $('.sp_end_us').css('display','none');
         $('.jtpl_col_count_cstm').addClass('cstm_opacity');
         $('.tagnewspecial').css('opacity','0');
          localStorage.setItem('countryus', 'no');
         $('.col_card_gift_svg').css('display','none');
       }
    }
  });
 $(".sourcing_ultra").click(function(){
  $(".jtpl_Progress_bar_main_link1").hide();
  $(".jtpl_Progress_bar_main_link2").show();
  $(".jtpl_Progress_bar_main_link3").hide();
  $(".raw_tab_1").addClass("active");
  $(".rw_mt_1").css("display", "block");

});
  
$('body').on('click','.button.button--secondary.custom_appointment_button',function(e) {
var getLink = $(this).attr('data-attr');
e.preventDefault();
    $("body").removeClass("show-website-popup");
    $(this).closest(".popup-overlay-content").removeClass("show-popup-content");
    Calendly.initPopupWidget({ url: getLink });
    

});
  $('body').on('click','.button.button--secondary.virtual-appointmet-btn',function(e) {
var getLink1 = $(this).attr('data-attr');

    e.preventDefault();
    $("body").removeClass("show-website-popup");
    $(this).closest(".popup-overlay-content").removeClass("show-popup-content");
    Calendly.initPopupWidget({ url: getLink1 });
    

});

  
$('.virtual_appointment').click(function(){

  $("body").addClass("show-website-popup");
  $("#website-video-appointment").addClass("show-popup-content");
}) 

$('.close-popup').click(function(){

  $("body").removeClass("show-website-popup");
  $("#website-video-appointment").removeClass("show-popup-content");
})

  
  
$(".soonerpopup-jtpl").hover(function(){
     $('.popover-gift-pdp').css("display", "block");
  }, function(){
     $('.popover-gift-pdp').css("display", "none");
  });
  

  
 
  $('.header__icon--cart').on('click', function(event) {
   
     if ($('body').hasClass('is-cart-active')) {
   // Redirect to the desired URL on any click
        window.location.href = `https://my-solitaire.myshopify.com/cart`;
       } else{
       event.preventDefault()
       }
    
  });



$('.active-facets__button-remove').click(function(){
  var specialOcassioncollection = document.getElementById('collectionName').value; 
  localStorage.setItem('specialOccasionValue'+specialOcassioncollection, 'no');
});


  
$(".jtpl-custom-cart-drawer a[href='/cart']").replaceWith(function() {
    return $(this).text().trim() ? "<div>" + $(this).text() + "</div>" : "";
});

$('.disclosure__button').click(function() {
    $(".disclosure__list").toggleClass("active");
    $('.header__icon').attr('aria-expanded', 'true');

  
  
})

var hdrIcnHgt = $('.icons_wrapper_main').height();
var hdrAnnSct = $('#shopify-section-announcement-bar').height();
var ttlhdrHeight = hdrIcnHgt + hdrAnnSct + 50;
$('.bg-of-icon-sct').css('height', ttlhdrHeight);
$('.drawer').css('top', ttlhdrHeight);

$(window).scroll(function() {

    if ($(".megaContainer").hasClass("sticky_header")) {

        var hdrIcnHgt1 = $('.left_icons_container').height();
        $('.bg-of-icon-sct.sticky-custom-cart').css('height', hdrIcnHgt1);
        $('.left_icons_container .drawer').css('top', hdrIcnHgt1);
    } else {
        var hdrIcnHgt = $('.icons_wrapper_main').height();
        var hdrAnnSct = $('#shopify-section-announcement-bar').height();
        var ttlhdrHeight = hdrIcnHgt + hdrAnnSct + 50;
        $('.bg-of-icon-sct').css('height', ttlhdrHeight);
        $('.drawer').css('top', ttlhdrHeight);

    }


});


$(document).on('click', 'body.is-cart-active', function() {
 
    $('body').removeClass('is-cart-active');
     $('.bg-of-icon-sct').removeClass('active-bg');
    $('.drawer').css('visibility', 'hidden');
    $('.drawer').css('height', '0');

});
jQuery.getJSON('/cart.js', function(cart, textStatus) {

    var getCount = cart.item_count;
    $('.custom_cart.cart-count-bubble span[aria-hidden="true"]').text(getCount);
    $('.icon.icon-cart-empty span[aria-hidden="true"]').text(getCount);
    $('.cart-count-bubble span[aria-hidden="true"]').text(getCount);
    if (getCount > 0) {
        $('button#CartDrawer-Checkout').removeAttr('disabled');
        $('.drawer').removeClass('is-empty');
        var getPrice = cart.total_price / 100;
        
        var formattedPrice = Shopify.formatMoney(cart.total_price);
    //  alert(formattedPrice);
        var splitCurrency = formattedPrice.replace('$', '');

        
        var getCurrency = $('body').attr('data-currency');
        $('.totals__subtotal-value').text(getCurrency + splitCurrency);
        
    }
});


$(window).scroll(function() {
    $('body').removeClass('body-has-announcemenbar');
});
var getBodyHtml = $('body').html();
if ((getBodyHtml).includes('announcement_bar_bg')) {

    $('body').addClass('body-has-announcemenbar');
} else {
    $('body').removeClass('body-has-announcemenbar');
}
$('a#cart-icon-bubble').mouseenter(function() {

    jQuery.getJSON('/cart.js', function(cart, textStatus) {


        var getCount1 = cart.item_count;
        //alert(getCount);
        if (getCount1 > 0) {
            setTimeout(function() {
                $('button#CartDrawer-Checkout').removeAttr('disabled');
            }, 1000);
        }
        setTimeout(function() {
            $('.custom_cart.cart-count-bubble span[aria-hidden="true"]').text(getCount1);
            $('.icon.icon-cart-empty span[aria-hidden="true"]').text(getCount1);
            $('.cart-count-bubble span[aria-hidden="true"]').text(getCount1);
        }, 1000);
    });
});



$('.drawer').mouseenter(function() {
    $('body').addClass('cart-hover');
});
$(document).on('mouseleave', '.drawer', function() {

    $('body').removeClass('cart-hover');
});




$('a#idcart , a#cart-icon-bubble, cart-drawer.drawer, .jtpl-custom-cart-drawer').mouseenter(function() {
    
    jQuery.getJSON('/cart.js', function(cart, textStatus) {


        var getCount1 = cart.item_count;
        
        if (getCount1 > 0) {
            $('button#CartDrawer-Checkout').removeAttr('disabled');
        }
        $('.custom_cart.cart-count-bubble span[aria-hidden="true"]').text(getCount1);
        $('.icon.icon-cart-empty span[aria-hidden="true"]').text(getCount1);
        $('.cart-count-bubble span[aria-hidden="true"]').text(getCount1);
        if (getCount1 > 0) {
            $('button#CartDrawer-Checkout').removeAttr('disabled');
            $('.drawer').removeClass('is-empty');
            var getPrice = cart.total_price / 100;
            console.log(getPrice);
          // alert(1);
            var formattedPrice = Shopify.formatMoney(cart.total_price);
           
            var splitCurrency = formattedPrice.replace('$', '');

           
            var getCurrency = $('body').attr('data-currency');
            $('.totals__subtotal-value').text(getCurrency + splitCurrency);

        }
      
 

    });
    $('body').addClass('is-cart-active');
    $('.bg-of-icon-sct').addClass('active-bg');
    $('cart-drawer.drawer').css('height', '100vh !important');
    $('.jtpl-custom-cart-drawer').removeClass('is-cart-close');

});

$(document).on('mouseleave', 'a#idcarte , #cart-icon-bubble, cart-drawer.drawer, .jtpl-custom-cart-drawer', function() {
    $('body').removeClass('is-cart-active');
    $('.drawer').css('height', '0vh');
    $('.drawer').css('visibility', 'hidden');
    $('.drawer').css('transition', 'visibility 0.5s ease-in-out, height 0.5s ease-in-out');
    $('.bg-of-icon-sct').removeClass('active-bg');

});

$(document).on('mouseleave', '.jtpl-custom-cart-drawer .drawer', function() {
   $('.jtpl-custom-cart-drawer').addClass('is-cart-close');
});

$('body').on('change','.custom_metafield_data',function () { 
    var getSelectedClickValue = $(".custom_metafield_data option").filter(":selected").text();
    $('span.custom_meta_data_wrapper').text(getSelectedClickValue);
    var getData = $('.get_selected_values_pdp_wrapper.jtpl-title-desktop').text();
    var getData1 = $('.get_selected_values_pdp_wrapper.jtpl-title-mobile').text();
    var newText = removeLastText(getData);
    var newText1 = removeLastText(getData1);
    var finalResult = newText +' '+getSelectedClickValue;
    var finalResult1 = newText1 +' '+getSelectedClickValue;
   $('.get_selected_values_pdp_wrapper').text(finalResult1); 
   $('.get_selected_values_pdp_wrapper').text(finalResult);
});



  
function removeLastText(text) {
  return text.substring(0, text.lastIndexOf(" "));
}

 // hide header on scroll down 
const section = document.querySelector('.section-header');
const sectionBar = document.querySelector('#shopify-section-announcement-bar');

if (sectionBar === null) {
} else{   
let lastScrollTop = 0;
 window.addEventListener('scroll', () => {

const currentScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
const isScrollingDown = currentScrollTop > lastScrollTop;
if(currentScrollTop <= 0 ){
    if ($(window).width() < 992) {
    $('aside').css('display','none');

   $('.megaHeader').css("height","108px").css("margin-top","0");
    document.querySelector(".header").classList.remove("sticky-header-center")
    $('.index_page .header-wrapper').addClass('transprant');
    $('.index_page .header-wrapper').css('position','unset');
    $('.index_page .second_logo').css('display','block');
    $('.index_page .primary_logo').css('display','none'); 

    $('.filter_trans_header .header-wrapper').removeClass('transprant');
    $('.filter_trans_header .header-wrapper').css('position','fixed');
    $('.filter_trans_header .second_logo').css('display','none');
    $('.filter_trans_header .primary_logo').css('display','block'); 

    $('.filter_trans_header #shopify-section-header sticky-header').css("top","0");
      
    }
    
    if ($(window).width() > 992) {
       $('.collection-engagement-ring-settings-shape aside,.collection-necklaces-and-pendants aside,.search aside').css('display','block').css('position','sticky');
      
    }
  setTimeout(function() {
   
     
    section.classList.remove('darkHeader');
    section.classList.add('lightHeader');
    // $('aside').removeClass('darkHeaderaside');
    // $('aside').addClass('lightHeaderaside');
    sectionBar.classList.add('lightHeaderAnnounce');
    },800);
} else{
   if ($(window).width() < 992) {
    $('aside').css('display','block');
      $('#shopify-section-header sticky-header').css("top","0");
   }
  if ($(window).width() > 992) {

         $('.not_transparent .header-wrapper').css("position","fixed").css("top","0").css("left","0").css("width","100%");
    }
  if (isScrollingDown) {
     setTimeout(function() {
    section.classList.add('darkHeader');
    section.classList.remove('lightHeader');
    // $('aside').addClass('darkHeaderaside');
    // $('aside').removeClass('lightHeaderaside');
    sectionBar.classList.add('lightHeaderAnnounce');
     },500);
  } else {
  setTimeout(function() {
     section.classList.remove('darkHeader');
     // $('aside').addClass('lightHeaderaside');
     // $('aside').removeClass('darkHeaderaside');
     section.classList.remove('darkHeader');
     section.classList.add('lightHeader');
     sectionBar.classList.remove('lightHeaderAnnounce');
   },500);
  }
}
lastScrollTop = currentScrollTop;
});

}

  
 // hide header on scroll down 


  
 // mobile outer search click start
 $('body').on('click', '.cstn_cross_icon_close_drawer', function() {
     $('body').removeClass('overflow-hidden-tablet');
     $('details.menu-drawer-container').removeClass('menu-opening');
     $('details.menu-drawer-container').removeAttr('open');
     $('summary.header__icon').attr('aria-expanded', 'false');
     $('.galleryH.slider-for.sliderContent').show();
     $('.custom_search_suggestion_options_wrapper').hide();
     $('section.announcement_bar_bg').show();
 });


 $('body').on('click', '.outer_search_clickable_jtpl .search_close_outer', function() {

     $('.outer_search_clickable_jtpl').removeClass('jtpl_serch_animation');

     setTimeout(function() {
         $('.outer_search_clickable_jtpl').hide();
     }, 700);
     $('.outer_search_clickable_jtpl').css('visibility', 'hidden');
     $('.outer_search_clickable_jtpl').css('opacity', '0');
 });

 $('body').on('click', 'img.custom_mob_serach_croos', function() {
     $('.formSearchcustom_hedear_outer_search').hide();
     $('.shopify-section.section-header').show();
     $('section.announcement_bar_bg').show();
     $('.custom_search_suggestion_options_wrapper_outer').hide();
     $('.custom_search_suggestion_options_wrapper.outer_suggestion').hide();
 });
 $('body').on('click', 'summary.header__icon', function() {

     $('.formSearchcustom_hedear_outer_search').show();
     $('section.announcement_bar_bg').hide();
     $('.formSearchcustom_hedear_outer_search input').trigger('focus');
 });

 $('body').on('click', 'input.darwer_inser.search__input.field__input', function() {
     $('.custom_search_suggestion_options_wrapper.drawer_suggestion').show();
 });
 $(document).on('click', '.cstm_mobile_serach_jtpl', function() {
     $('.outer_search_clickable_jtpl').show();
     $('.custom_search_suggestion_options_wrapper.outer_suggestion').css('display', 'block');
     $('.outer_search_clickable_jtpl').css('visibility', 'visible');
     $('.outer_search_clickable_jtpl').css('opacity', '1');
     $('.outer_search_clickable_jtpl').addClass('jtpl_serch_animation');
     $('.formSearchcustom_hedear_outer_search').show();
     //$('.shopify-section.section-header').hide();
     //$('section.announcement_bar_bg').hide();
 });
 $('.menu-drawer__inner-container input').keyup(function() {

     $('.custom_search_suggestion_options_wrapper').hide();
 });
 // mobile outer search click end
  



  
/***18 DEC 2023 Collection quick add***/
 //initializeEnter();
 //withoutMetal();
 initializeSlickOnlyMetal();
 //initializeMetalSlick();
 // $('li.grid__item').mouseleave(function() {
    $(document).on('mouseleave', 'li.grid__item', function() {  
        $('a.add_quick_btn').show();
        $('a.add_quick_btn_no_metal').show();
        $('a.add_quick_btn_one_metal').show();
        $('.jtpl_one_metalstep1').hide();
        $('.jtpl_one_metalstep2').hide();
        $('.jtpl_one_metalstep3').hide();
        $('.jtpl_onlyMetal1').hide();
        $(".Onlymetal_name3").hide();
        //$('.tick_jtpl_svg_adding').hide();
        //$('.tick_jtpl_svg_add').hide();
        $('.addtoBag').hide();
        $('.jtpl_no_metalstep1').hide();
        $('.jtpl_no_metalstep2').hide();
        $('.jtpl_no_metalstep3').hide();
        $('.jtpl_no_metalstep4').hide();
        $('.jtpl_step1').hide();
        $('.jtpl_step2').hide();
        $('.jtpl_step3').hide();
    });




 $(document).on('mouseleave', '.img_hover_content', function() {  
  //$('.img_hover_content').mouseleave(function() {
        $(this).find('a.add_quick_btn_one_metal').css('display', 'block');
        $('.jtpl-varant-list2').removeClass('second-macthed-data');
        $('.jtpl-varant-list1').removeClass('macthed-data');
        $('.jtpl-oneMetavarant-list1').css('display', 'block');
        $('.jtpl-varant-list1').removeClass('macthed-data');
        $(this).find('a.add_quick_btn_no_metal').css('display', 'block');
        $(this).find('a.add_quick_btn').css('display', 'block');
         $(this).find('a.add_quick_btn_onlyMetal').css('display', 'block');

    
      //$('.tick_jtpl_svg_adding').hide();
        $('.tick_jtpl_svg_add').hide();
        $('.addtoBag').hide();
         $(".Onlymetal_name3").hide();

        $(this).find('.caret_size_content').hide();
    
         $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step1').hide();
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step2').hide();
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step3').hide();
    
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_one_metalstep1').hide();
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_one_metalstep2').hide();
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_one_metalstep3').hide();

        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_no_metalstep1').hide();
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_no_metalstep2').hide();
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_no_metalstep3').hide();
        //$(this).parents('.img_hover_content').find('.tick_last_mainno').hide();
    });




  
     $('body').on('click', 'img.jtpl-variant-img', function() {
    $(this).parents('.jtpl-pro-variant-cstm-popup').find('img.jtpl-variant-img').removeClass('jtpl_selected');
    $(this).parents('.jtpl-pro-variant-cstm').find('img.jtpl-variant-img').removeClass('jtpl_selected');
    $(this).parents('.jtpl-pro-variant-cstm-gem').find('img.jtpl-variant-img').removeClass('jtpl_selected');
    $(this).parents('.jtpl-pro-variant-cstm-new').find('img.jtpl-variant-img').removeClass('jtpl_selected');
    $(this).addClass('jtpl_selected');
    });

  
    var get_length = $('.icon.icon-cart-empty .cart-count-bubble span').text();
 
    var pasre = parseInt(get_length);
    if (pasre <= 1) {
        $('.icon.icon-cart-empty .cart-count-bubble ').show();
    } else {
        $('button#CartDrawer-Checkout').attr('disabled', '');
    }

    if (pasre == 0) {
        $('button#CartDrawer-Checkout').attr('disabled', 'disabled');
    }
  
  function initializeTick() {
        setTimeout(function() {
            $(this).parents('.img_hover_content').find('.tick_last_main').hide();
            $(this).parents('.img_hover_content').find('.quick_add_btn a.add_quick_btn').show();
        }, 500);
    }

  function initializeTick() {
        setTimeout(function() {
            $(this).parents('.img_hover_content').find('.tick_last_main').hide();
            $(this).parents('.img_hover_content').find('.quick_add_btn a.add_quick_btn').show();
        }, 500);
    }
  

        $(document).on('mouseenter', '.quick_add_btn a.add_quick_btn', function() { 
        //$('.quick_add_btn a.add_quick_btn').mouseenter(function() {
     
        $('.tick_last_main').hide();
        $('.addtoBag').hide();
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step1').css('display', 'block');
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step2').css('display', 'none');
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step3').css('display', 'none');
      
        $(this).parents('.img_hover_content').find('.caret_size_content').show();
          initializeEnterSlick();  
          
          
            $(this).hide();
        
        });
    
  


function initializeMetalSlick() {


 $('.jtpl-pro-variant-cstm').slick({

 dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 8,
  slidesToScroll: 4,
    responsive: [
    {
      breakpoint: 768, 
      settings: {
        slidesToShow: 6,
        arrows:false,
      },
    },
  ],
});

}
  
 function initializeMetalSlick2() {

        if ($('.jtpl_no_metalvariant2').hasClass('slick-initialized')) {
            $('.jtpl_no_metalvariant2').slick('unslick');
        }
        $('.jtpl_no_metalvariant2').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
        });
    }

  function withoutMetal() {

        if ($('.jtpl_one_metalvariant1').hasClass('slick-initialized')) {
            $('.jtpl_one_metalvariant1').slick('unslick');
        }
        $('.jtpl_one_metalvariant1').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
        });
    }


  function withMetalSize() {
        if ($('.jtpl_one_metalvariant2').hasClass('slick-initialized')) {
            $('.jtpl_one_metalvariant2').slick('unslick');
        }
        $('.jtpl_one_metalvariant2').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
        });
    }
function withoutMetalWithSize(){
 if ($('.jtpl_no_metalvariant4').hasClass('slick-initialized')) {
  $('.jtpl_no_metalvariant4').slick('unslick');
        }
$('.jtpl_no_metalvariant4').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
        });
  
}
  
  function initializeSlick() {

        if ($('.jtplcaret_size.jtpl_variant2.jtpl_varlists2').hasClass('slick-initialized')) {
            $('.jtplcaret_size.jtpl_variant2.jtpl_varlists2').slick('unslick');
        }
        $('.jtplcaret_size.jtpl_variant2.jtpl_varlists2').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
        });
    }

  
  function initializeSlick3() {
        if ($('.jtplcaret_size.jtpl_variant3').hasClass('slick-initialized')) {
            $('.jtplcaret_size.jtpl_variant3').slick('unslick');
        }
         $('.jtplcaret_size.jtpl_variant3').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 1,
      });
        
    }

   function initializeSlickOnlyMetal() {
          if ($('.jtplcaret_size.jtpl_onlyMetal1').hasClass('slick-initialized')) {
              $('.jtplcaret_size.jtpl_onlyMetal1').slick('unslick');
          }
           $('.jtplcaret_size.jtpl_onlyMetal1').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
        });
          
      }


    function initializeEnterSlick() {

        if ($('.jtplcaret_size.jtpl_variant1.jtpl_varlists1').hasClass('slick-initialized')) {
            $('.jtplcaret_size.jtpl_variant1.jtpl_varlists1').slick('unslick');
        }
        $('.jtplcaret_size.jtpl_variant1.jtpl_varlists1').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
        });
    }

  /*** quick add no metal variant ****/
  $(document).on('mouseover', 'a.add_quick_btn_no_metal', function() {
       
        $(this).parents('.img_hover_content').find('a.add_quick_btn_no_metal').css('display', 'none');
        $('.tick_jtpl_svg_adding').hide();
        $('.tick_jtpl_svg_add').hide();
        $('.addtoBag').hide();
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_no_metalstep1').css('display', 'block');
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_no_metalstep2').css('display', 'none');
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_no_metalstep3').css('display', 'none');
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_no_metalstep4').css('display', 'none');
        $(this).parents('.img_hover_content').find('.caret_size_content').show();
     
      if ($('.jtpl_no_metalvariant1').hasClass('slick-initialized')) {
            $('.jtpl_no_metalvariant1').slick('unslick');
        }
        $('.jtpl_no_metalvariant1').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
        });
  
      
    });


$('body').on('click', '.jtpl-noMetavarant-list1', function() {
 //$('.jtpl-noMetavarant-list1').on('click', function() {
        var variantDataVal = '';
        var variantDataVal2 = '';
        var variantDataVal3 = '';
        var selectedAltText = '';
        var get_combo = '';
        var dataAttrValue = $(this).data('attr');
        var variantDataVal = $(this).data('val');
        var dataAttrValue = $(this).data('attr');
        var dataAttrthird = $(this).data('third');
        var dataAttrSecond = $(this).data('carat');
        var dataAttrFirst = $(this).data('quality');
        var dataSelect1= $(this).data('select');
        var dataAttrVarNoMetal = $(this).data('var');
        $(this).parents('.caret_size_content').find('.jtpl_no_metalstep2').css('display', 'block');
        $(this).parents('.caret_size_content').find('.jtpl_no_metalstep1').css('display', 'none');
        initializeMetalSlick2();

   if(dataSelect1 == ""){
      var get_comboVarCOmbo = variantDataVal + ' | ' + dataAttrSecond + ' | ' + dataAttrthird;
   }else{
       var get_comboVarCOmbo = variantDataVal + ' | ' + dataAttrSecond + ' | ' + dataAttrthird+ dataSelect1;
   }
   
       
        var get_comboVarCOmbo22 = variantDataVal + ' / ' + dataAttrSecond + ' / ' + dataAttrthird;
        $(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVarCOmbo);


        const variantElements8 = $('.cstm-hide-select');
        let selectedVariantValuePrice8;
        let selectedVariantSku8;
        let selectedVariantValue8;
        variantElements8.each(function() {
            const variantElement8 = $(this);
            const variantDataAttr8 = variantElement8.data('attr');

            if (variantDataAttr8 === dataAttrValue) {

                variantElement8.find('option').each(function() {
                    const optionText8 = $(this).text();
                  
                     if (optionText8.includes(selectedAltText)) {
                                optionText8new = optionText8;
            
                                if (optionText8new.includes(variantDataVal)) {
            
                                    var secondVar = optionText8new.split('/');
                                    var soption1 = secondVar[1].trim(' ', '');
            
                                    var gte_select_val_second = '';
                                    $('.jtpl-varant-list2').each(function() {
                                        gte_select_val_second = $(this).attr('data-val');
                                        var gte_select_attr_second = $(this).data('attr');
                                        if (gte_select_val_second === soption1) {
            
                                            $(this).addClass('second-macthed-data');
                                        }
                                        setTimeout(function() {
            
                                            $('.jtpl-varant-list2:not(.second-macthed-data)').hide();
                                        }, 100);
                                    });
            
                                }
                            }
                    if (optionText8 === get_comboVarCOmbo22) {

                        selectedVariantValue8 = $(this).val();
                        selectedVariantValuePrice8 = $(this).data('price');
                        selectedVariantSku8 = $(this).data('sku');
                          
                        $("span#jtpl_price-item_" + dataAttrValue).text(selectedVariantValuePrice8);
                        return false;

                    }
                });


            }
        });




        $('body').on('click', '.jtpl-noMetavarant-list2', function() {
            var variantDataVal2 = $(this).data('val');
           
           if(dataSelect1 == ""){
          var get_comboVarCOmbo2 = variantDataVal + ' | ' + variantDataVal2 + ' | ' + dataAttrthird;
       }else{
           var get_comboVarCOmbo2 = variantDataVal + ' | ' + variantDataVal2 + ' | ' + dataAttrthird+ dataSelect1;
       }
   
            var get_comboVarCOmbo44 = variantDataVal + ' / ' + variantDataVal2 + ' / ' + dataAttrthird;
            $(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVarCOmbo2);
            const variantElements8 = $('.cstm-hide-select');
            let selectedVariantValuePrice10;
            let selectedVariantSku10;
            let selectedVariantValue10;
            variantElements8.each(function() {
                const variantElement8 = $(this);
                const variantDataAttr8 = variantElement8.data('attr');

                if (variantDataAttr8 === dataAttrValue) {

                    variantElement8.find('option').each(function() {
                        const optionText8 = $(this).text();

                        if (optionText8 === get_comboVarCOmbo44) {

                            selectedVariantValue10 = $(this).val();
                            selectedVariantValuePrice10 = $(this).data('price');
                            selectedVariantSku10 = $(this).data('sku');

                            $("span#jtpl_price-item_" + dataAttrValue).text(selectedVariantValuePrice10);
                            return false;

                        }
                    });


                }
            });


            $('body').on('click', '.jtpl-noMetavarant-list3', function() {


          if(dataAttrVarNoMetal == 1){
               withoutMetalWithSize();
                $(this).parents('.img_hover_content').find('.addtoBag').hide();
               $(this).parents('.caret_size_content').find('.jtpl_no_metalstep4').css('display', 'block');
                 $(this).parents('.caret_size_content').find('.jtpl_no_metalstep3').css('display', 'none');

                
            
          } else{
               $(this).parents('.img_hover_content').find('.addtoBag').show();
                $('.carat_size_main.jtpl_no_metalstep3').hide();


            
          }

              
               
                var variantDataVal3 = $(this).data('val');
                var get_combo = variantDataVal + ' / ' + variantDataVal2 + ' / ' + variantDataVal3;
              
                if(dataSelect1 == ""){
                      var get_comboVarCOmbo = variantDataVal + ' | ' + variantDataVal2 + ' | ' + variantDataVal3;
                   }else{
                       var get_comboVarCOmbo = variantDataVal + ' | ' + variantDataVal2 + ' | ' + variantDataVal3+ dataSelect1;
                   }
                $(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVarCOmbo);


                const variantElements1 = $('.cstm-hide-select');
                let selectedVariantValue;
                let selectedVariantValuePrice9;
                let selectedVariantSku9;
                variantElements1.each(function() {
                    const variantElement1 = $(this);
                    const variantDataAttr1 = variantElement1.data('attr');

                    if (variantDataAttr1 === dataAttrValue) {

                        variantElement1.find('option').each(function() {
                            const optionText = $(this).text();

                            if (optionText === get_combo) {

                                selectedVariantValue = $(this).val();
                                selectedVariantValuePrice9 = $(this).data('price');
                                selectedVariantSku8 = $(this).data('sku');
                                $("span#jtpl_price-item_" + dataAttrValue).text(selectedVariantValuePrice9);
                                return false;

                            }
                        });


                    }
                });
        if(dataAttrVarNoMetal == 1){
             $('body').on('click', '.jtpl-noMetavarant-list4', function() {
            $(this).parents('.img_hover_content').find('.addtoBag').show();
            $(this).parents('.caret_size_content').find('.jtpl_no_metalstep4').css('display', 'none');
              var variantDataVarLineitem1 = $(this).data('val');  
              var get_comboVarThirdDataVal1 = variantDataVal + ' | ' + variantDataVal2 + ' | ' + variantDataVal3+ ' | '+variantDataVarLineitem1;
               $(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVarThirdDataVal1);
         
         $('body').on('click', '.addtoBag', function() {

                    $(this).parents('.img_hover_content').find('.tick_jtpl_svg_adding').show();
                    $(this).parents('.caret_size_content').find('.jtpl_no_metalstep1').css('display', 'none');
                    $(this).parents('.caret_size_content').find('.jtpl_no_metalstep2').css('display', 'none');
                    $(this).hide();



                    $.ajax({
                        url: '/cart/add.js',
                        type: 'POST',
                        data: {
                            id: selectedVariantValue,
                            quantity: 1,
                            properties: {
                                Size: variantDataVarLineitem1,
                             }
                          
                        },
                        success: function(response) {
                            $('.quick_add_btn_metal').css('display', 'block');
                            $('.caret_size_content').show();
                            $('.tick_jtpl_svg_add').css('display', 'flex');
                            $('.tick_jtpl_svg_adding').hide();
                            //$('.carat_size_main.jtpl_no_metalstep1').hide();
                           $('a.add_quick_btn_no_metal').hide();
                            setTimeout(function() {
                               
                                $('.jtpl_no_metalstep1').css('display', 'block');
                                $('.jtpl_no_metalstep2').css('display', 'none');

                                $('.tick_jtpl_svg_add').hide();
                               
                            }, 4000);
                            setTimeout(function() {
                                $(".jtpl-custom-cart-drawer").load(location.href + " .cart-count-bubble");
                                $(".jtpl-custom-cart-drawer").load(location.href + " .drawer");
                                $(".jtpl-custom-cart-drawer-1").load(location.href + " .cart-count-bubble");
                                $(".jtpl-custom-cart-drawer-1").load(location.href + " .drawer");
                                var bubbleValue = $('.cart-count-bubble:first span[aria-hidden="true"]').text();
                                var convertInt = parseFloat(bubbleValue);
                                var addOne = convertInt + 1;
                                setTimeout(function() {
                                    $('.cart-count-bubble span[aria-hidden="true"]').text(addOne);
                                    $('.cart-count-bubble').addClass('product-added');
                                }, 1000);
                                setTimeout(function() {
                                    $('.cart-count-bubble').removeClass('product-added');
                                }, 2000);
                                setTimeout(function() {
                                    $('button#CartDrawer-Checkout').removeAttr('disabled');
                                }, 1000);
                            }, 500);

                        }
                    });

                    });
                });
        } else{
                $('body').on('click', '.addtoBag', function() {

                    $(this).parents('.img_hover_content').find('.tick_jtpl_svg_adding').show();
                    $(this).parents('.caret_size_content').find('.jtpl_no_metalstep1').css('display', 'none');
                    $(this).parents('.caret_size_content').find('.jtpl_no_metalstep2').css('display', 'none');
                    $(this).hide();



                    $.ajax({
                        url: '/cart/add.js',
                        type: 'POST',
                        data: {
                            id: selectedVariantValue,
                            quantity: 1,
                        },
                        success: function(response) {
                            $('.quick_add_btn_metal').css('display', 'block');
                            $('.caret_size_content').show();
                            $('.tick_jtpl_svg_add').css('display', 'flex');
                            $('.tick_jtpl_svg_adding').hide();
                          
                           $('a.add_quick_btn_no_metal').hide();
                            setTimeout(function() {
                               
                                $('.jtpl_no_metalstep1').css('display', 'block');
                                $('.jtpl_no_metalstep2').css('display', 'none');

                                $('.tick_jtpl_svg_add').hide();
                               
                            }, 4000);
                            setTimeout(function() {
                                $(".jtpl-custom-cart-drawer").load(location.href + " .cart-count-bubble");
                                $(".jtpl-custom-cart-drawer").load(location.href + " .drawer");
                                $(".jtpl-custom-cart-drawer-1").load(location.href + " .cart-count-bubble");
                                $(".jtpl-custom-cart-drawer-1").load(location.href + " .drawer");
                                var bubbleValue = $('.cart-count-bubble:first span[aria-hidden="true"]').text();
                                var convertInt = parseFloat(bubbleValue);
                                var addOne = convertInt + 1;
                                setTimeout(function() {
                                    $('.cart-count-bubble span[aria-hidden="true"]').text(addOne);
                                    $('.cart-count-bubble').addClass('product-added');
                                }, 1000);
                                setTimeout(function() {
                                    $('.cart-count-bubble').removeClass('product-added');
                                }, 2000);
                                setTimeout(function() {
                                    $('button#CartDrawer-Checkout').removeAttr('disabled');
                                }, 1000);
                            }, 500);

                        }
                    });


                });
            }
            });
        });


    });

  /*** quick add no metal variant ****/

  

/***quick add with only metal and variant from metafield****/
$(document.body).on('mouseenter', '.quick_add_btn a.add_quick_btn_onlyMetal', function() {
//$('.quick_add_btn a.add_quick_btn_onlyMetal').mouseenter(function() {

   $('.caret_size_content').css('display', 'block');
   $(this).parents('.img_hover_content').find('.caret_size_content').show();
    $(this).parents('.img_hover_content').find('.jtpl_onlyMetal1').show();
  $(this).parents('.img_hover_content').find('.jtpl_step_onlyMetal1').show();
 $(".Onlymetal_name3").show();
    initializeSlickOnlyMetal();
    $(this).parents('.img_hover_content').find('.tick_last_main').hide();
    $(this).parents('.img_hover_content').find('.tick_jtpl_svg_addingno').hide();
    $(this).parents('.img_hover_content').find('.tick_jtpl_svg_addno').hide();
    $(this).hide();
});


$('body').on('click', '.jtpl-onlyMetal-list1', function() {
//$('.jtpl-onlyMetal-list1').on('click', function() {

        var dataAttrValue = $(this).data('attr');
        var dataAttrVarValue= $(this).data('var');
        var dataAttrSelect3 = $(this).data('select');
    
        var variantDataVal = '';
        var variantDataVal2 = '';
        var variantDataVal3 = '';
        var selectedAltText = '';
        var get_combo = '';
        var selectedAltText = '';
        var variantDataVarLineitemOnlyMetal = $(this).data('val');
        $(this).parents('.img_hover_content').find('.add_to_bag_OnlyMetal').css('display', 'block');
        $(this).parents('.img_hover_content').find('.addtoBag').css('display', 'block');
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step_onlyMetal1').hide();

        const variantElements = $('.jtpl-pro-variant-cstm');

        variantElements.each(function() {
            var variantElement = $(this);
            var variantDataAttr = variantElement.data('attr');


            if (variantDataAttr === dataAttrValue) {


                var variantDiv = variantElement.find('.jtpl_selected');


                if (variantDiv.hasClass('jtpl_selected')) {

                    selectedAltText = variantDiv.attr('alt');
                    return;
                }
            }
        });


        var variantDataVal = $(this).data('val');
        

        var get_combo = selectedAltText;
        var get_comboWithMetal = selectedAltText + ' | '+ variantDataVarLineitemOnlyMetal;

      
        $(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboWithMetal);


        const variantElements1 = $('.cstm-hide-select');
        let selectedVariantValue;
        let selectedVariantPriceMetal;
        let selectedVariantSku12;
        variantElements1.each(function() {
            const variantElement1 = $(this);
            const variantDataAttr1 = variantElement1.data('attr');

            if (variantDataAttr1 === dataAttrValue) {

                variantElement1.find('option').each(function() {
                    const optionText = $(this).text();

                    if (optionText === get_combo) {
                          
                        selectedVariantValue = $(this).val();
                      
                        selectedVariantPriceMetal = $(this).data('price');
                        selectedVariantSku12 = $(this).data('sku');
                        $("span#jtpl_price-item_" + dataAttrValue).text(selectedVariantPriceMetal);
                        return false;

                    }
                });


            }
        });

       if (selectedVariantSku12 != "" ) {
            
            var imgnew = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-1.jpg';
              checkImageExists(imgnew, function(exists) {
                        if (exists) {
                            $('.jtpl-card-image-update_' + dataAttrValue).find('img').attr('src', imgnew);
                        }

                  });
            
        }

  
        const variantElements8 = $('.slider-jtpl-nav');
        variantElements8.each(function() {
            const variantElement8 = $(this);
            const variantDataAttr8 = variantElement8.data('attr');


            if (variantDataAttr8 === dataAttrValue) {

                var count = 1;
                $(this).find('.main_slider_image').each(function(index, element_main) {
 
              
                    if (count == 1) {
                        var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-1.jpg';
                    } else if (count == 2) {
                        var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-2.jpg';
                    } else if (count == 3) {
                        var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-3.jpg';
                    } else if (count == 4) {
                        var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-4.jpg';
                    } else if (count == 5) {
                        var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-5.jpg';
                    }


                    count++;
                    checkImageExists(img, function(exists) {
                        if (exists) {
                            $(element_main).find('img').attr('src', img);
                        }

                    });
                });
            }
        });
         

$('body').on('click', '.addtoBag .add_to_bag_OnlyMetal', function() {
//$('.addtoBag .add_to_bag_OnlyMetal').click(function() {
            $(this).parents('.img_hover_content').find('.tick_last_main_metal').show();
            $('.tick_jtpl_svg_addingno').show();
              $('.tick_last_main_metal').show();
              $('.tick_jtpl_svg_addingno').show();
            $(this).hide();
            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: {
                    id: selectedVariantValue,
                    quantity: 1,
                    properties: {
                      Size: variantDataVarLineitemOnlyMetal,
                     }
                },
                success: function(response) {
                  
                    $('.tick_jtpl_svg_addingno').hide();
                    $('.tick_jtpl_svg_addno').show();
                    
                    setTimeout(function() {
                       initializeSlickOnlyMetal();
                       $('.tick_last_main_metal').hide();
                       $('.tick_jtpl_svg_addno').hide();
                        $('.caret_size_content').show();
                       $('a.add_quick_btn_onlyMetal').hide();
                      $('.jtpl_step_onlyMetal1').show();
                      
                    }, 4000);
                    setTimeout(function() {
                        $(".jtpl-custom-cart-drawer").load(location.href + " .cart-count-bubble");
                        $(".jtpl-custom-cart-drawer").load(location.href + " .drawer");
                        $(".jtpl-custom-cart-drawer-1").load(location.href + " .cart-count-bubble");
                        $(".jtpl-custom-cart-drawer-1").load(location.href + " .drawer");
                        var bubbleValue = $('.cart-count-bubble:first span[aria-hidden="true"]').text();
                        var convertInt = parseFloat(bubbleValue);
                        var addOne = convertInt + 1;
                        setTimeout(function() {
                            $('.cart-count-bubble span[aria-hidden="true"]').text(addOne);
                            $('.cart-count-bubble').addClass('product-added');
                        }, 1000);
                        setTimeout(function() {
                            $('.cart-count-bubble').removeClass('product-added');
                        }, 2000);
                        setTimeout(function() {
                            $('button#CartDrawer-Checkout').removeAttr('disabled');
                        }, 1000);
                    }, 500);

                }
            });
        }); 
    });

  
/***quick add with only metal and variant from metafield****/

  

   /*** quick add One Metal variant ****/
    
   // $('.quick_add_btn_metal a.add_quick_btn_one_metal').mouseenter(function() {
$(document.body).on('mouseenter', '.quick_add_btn_metal a.add_quick_btn_one_metal', function() {
        $('.addtoBag').hide();
        $('.caret_size_content').css('display', 'block');
        $('.tick_last_mainno').hide();
        $(this).closest('.img_hover_content').find('.carat_size_main.jtpl_one_metalstep1').show();
        $(this).closest('.img_hover_content').find('.tick_last_main').hide();
        $(this).closest('.img_hover_content').find('.carat_size_main.jtpl_one_metalstep2').hide();
        $(this).hide();
    });

  



       $(document).on('mouseover', 'a.add_quick_btn_one_metal', function() {
         withoutMetal();
        $(this).closest('.img_hover_content').find('a.add_quick_btn_one_metal').css('display', 'none');
       $(this).closest('.img_hover_content').find('.carat_size_main.jtpl_one_metalstep1').css('display', 'block');
       var selectedVariantValue = "";
       

    });
var selectedVariantValue = "";
var selectedVariantPriceMetal = "";
var selectedVariantSku12= "";
 $('body').on('click', '.jtpl-oneMetavarant-list1', function() {
      
 
        var dataAttrValue = $(this).data('attr');
        var dataAttrVarValue= $(this).data('var');
        var dataAttrSelect3 = $(this).data('select');
        var dataAttrIndex2 = $(this).data('index');
        var variantDataVal = '';
        var variantDataVal2 = '';
        var variantDataVal3 = '';
        var selectedAltText = '';
        var get_combo = '';
        var selectedAltText = '';
        var size_text='';
        var selectedval ='';
  
  if(dataAttrVarValue == 1){
     withMetalSize();
     $(this).parents('.img_hover_content').find('.add_to_bag').css('display', 'none');
        $(this).parents('.img_hover_content').find('.addtoBag').css('display', 'none');
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_one_metalstep2').show();
     $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_one_metalstep1').hide();
    
 
  } else{ 

        $(this).parents('.img_hover_content').find('.add_to_bag').css('display', 'block');
        $(this).parents('.img_hover_content').find('.addtoBag').css('display', 'block');
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_one_metalstep1').hide();
  }


   
        const variantElements = $('.jtpl-pro-variant-cstm');

        variantElements.each(function() {
            var variantElement = $(this);
            var variantDataAttr = variantElement.data('attr');


            if (variantDataAttr === dataAttrValue) {


                var variantDiv = variantElement.find('.jtpl_selected');


                if (variantDiv.hasClass('jtpl_selected')) {

                    selectedAltText = variantDiv.attr('alt');
                    return;
                }
            }
        });


        var variantDataVal = $(this).data('val');

        if(dataAttrIndex2 == "1"){
          var get_combo = selectedAltText + ' / ' + variantDataVal;
        } else{
          var get_combo = variantDataVal + ' / ' + selectedAltText;
        }
       
        if($(this).hasClass('size')){
          size_text="Size:";
        }
     
      if(dataAttrSelect3 == ""){
        var get_comboWithMetal = selectedAltText + ' | '+ size_text + variantDataVal;
      }else{
        var get_comboWithMetal = selectedAltText + ' | ' + size_text + variantDataVal+ dataAttrSelect3;
      }
      
        $(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboWithMetal);


        const variantElements1 = $('.cstm-hide-select');
       
      
   selectedVariantValue = '';
        variantElements1.each(function() {
         
            const variantElement1 = $(this);
            const variantDataAttr1 = variantElement1.data('attr');

            if (variantDataAttr1 === dataAttrValue) {

                variantElement1.find('option').each(function() {
                    const optionText = $(this).text();

                    if (optionText === get_combo) {
                         
                        selectedVariantValue = $(this).val();
                        selectedVariantPriceMetal = $(this).data('price');
                        selectedVariantSku12 = $(this).data('sku');
                        $("span#jtpl_price-item_" + dataAttrValue).text(selectedVariantPriceMetal);
                        return false;

                    }
                });


            }
        });
    
       if (selectedVariantSku12 != "" ) {
            
            var imgnew = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-1.jpg';
              checkImageExists(imgnew, function(exists) {
                        if (exists) {
                            $('.jtpl-card-image-update_' + dataAttrValue).find('img').attr('src', imgnew);
                        }

                  });
            
        }

  
        const variantElements8 = $('.slider-jtpl-nav');
        variantElements8.each(function() {
            const variantElement8 = $(this);
            const variantDataAttr8 = variantElement8.data('attr');


            if (variantDataAttr8 === dataAttrValue) {

                var count = 1;
                $(this).find('.main_slider_image').each(function(index, element_main) {
 
              
                    if (count == 1) {
                        var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-1.jpg';
                    } else if (count == 2) {
                        var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-2.jpg';
                    } else if (count == 3) {
                        var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-3.jpg';
                    } else if (count == 4) {
                        var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-4.jpg';
                    } else if (count == 5) {
                        var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku12 + '-5.jpg';
                    }


                    count++;
                    checkImageExists(img, function(exists) {
                        if (exists) {
                            $(element_main).find('img').attr('src', img);
                        }

                    });
                });
            }
        });
         
  

 $('body').on('click', '.addtoBag .add_to_bag.bag_'+dataAttrValue, function() { 

            $(this).parents('.card-wrapper').find('.cstm-hide-select option[data-val="'+get_combo+'"]').attr('value');
            $(this).parents('.img_hover_content').find('.tick_last_mainno').show();
            $(this).parents('.img_hover_content').find('.tick_last_main_metal').show();
            $(this).parents('.img_hover_content').find('.tick_jtpl_svg_addingone_metal').show();
            $(this).hide();

                 let productitems = [];
                productitems.push({
                    'vid': selectedVariantValue,
                    'pid': dataAttrValue
                }); 

                fetch('https://truesaniti.com/truesanity/product_inventory.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ productData: productitems })
                })
                .then(response => response.json())
                .then(response =>{
                   const txt = response;
                  
               

                  
                  const obj = JSON.parse(txt);
                
                  const inventory_qty = obj.inventory_qty; 
                  const qntymore = obj.quantity_more_than_1_ship_time;
                  const qntyless = obj.quantity_less_than_1_ship_time;
                  const varprice = obj.price;


             var skipDates = $('.skipDatesMeta').text();
            var qnty_more_data_meta = $('.qnty_more_data_meta').text();
            var qnty_less_data_meta = $('.qnty_less_data_meta').text(); 
           
            if(qntymore == undefined){
               var qnty_more_data = qnty_more_data_meta;
              } else{
              var qnty_more_data = qntymore;
             
             }  
            if(qntyless == undefined){
               var qnty_less_data = qnty_less_data_meta;
              } else{
              var qnty_less_data = qntyless;
                    
             } 
         

            if(inventory_qty >= 1){
              if(qnty_more_data == 0){
                 qnty_more_data_updated = qnty_more_data + 1;
               } else{
                 qnty_more_data_updated = qnty_more_data;
               }
             const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
            ];
             
            let today = new Date();
            const pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
            let hh = new Date(pstDate).getHours();
              
            
            
             if(hh > 15){
                var dd = today.getDate() + 1 ;
               }  else{
              var dd = today.getDate();
             }
            
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            
            var startDate = yyyy + '/' + mm + '/' + dd;
            startDate = new Date(startDate);
               
            var endDate = "";
            var noOfDaysToAdd = qnty_more_data_updated;
            var count = 0;
            var countabc = 0;
            var counttimes =0;
            while(count < noOfDaysToAdd){
              
            endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
              
           if (skipDates.includes(endDate.toISOString().substring(0, 10))) {
                continue;
              }
              
              
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {
                   
                  count++;
                }
              
            }
          
            
            const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];   
             var country_loc = localStorage.getItem("countryus");
           
              
                if(country_loc == "yes") {
                    if(varprice < 250 ){  
                        var newDate =  new Date(endDate.getTime() + (3 * 86400000));
                        var newDate2 = new Date(endDate.getTime() + (6 * 86400000));
                      if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1;
                      var newddrange = newDate2.getDate();
                   } else{
                       var newdd = newDate.getDate();
                      var newddrange = newDate2.getDate();
                   }
                    var newmm = newDate.getMonth() + 1;
                    
                  if(qnty_less_data == 0){
                     var dayrange = weekday[newDate2.getDay()];
                      var day = weekday[newDate.getDay() -1];
                   } else{
                      var dayrange = weekday[newDate2.getDay()];
                      var day = weekday[newDate.getDay()];
                   }
                          
                    var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayrange+', '+monthNames[newDate2.getMonth()] + ' ' +newddrange;
                
                    } else{
                      var newDate =  new Date(endDate.getTime() + (2 * 86400000));
                        if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1;
                     
                   } else{
                       var newdd = newDate.getDate();
                      
                   }
                    var newmm = newDate.getMonth() + 1;
                    
                  if(qnty_less_data == 0){
                    
                      var day = weekday[newDate.getDay() -1];
                   } else{
                     
                      var day = weekday[newDate.getDay()];
                   }
                         
                     var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
                
  
                    }
                  } else{

              
                   var newDate =  new Date(endDate.getTime()); 
                   if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1; 
                   } else{
                       var newdd = newDate.getDate();  
                   }
                   if(qnty_less_data == 0){
                    
                      var day = weekday[newDate.getDay() -1];
                   } else{
                  
                      var day = weekday[newDate.getDay()];
                   }
                      
                   var newmm = newDate.getMonth() + 1;
                  var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
                   
                 }  
             
            var text = document.createTextNode(finalDate).textContent;
            
            
             
            } else if(inventory_qty < 1){
               if(qnty_less_data == 0){
                 qnty_less_data_updated = qnty_less_data + 1;
               } else{
                 qnty_less_data_updated = qnty_less_data;
               }
              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
            ];
            
             let today = new Date();
            const pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
            let hh = new Date(pstDate).getHours();
              
           
            
             if(hh > 15){
                var dd = today.getDate() + 1 ;
               }  else{
              var dd = today.getDate();
             }
            
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            
            var startDate = yyyy + '/' + mm + '/' + dd;
            startDate = new Date(startDate);
               
            var endDate = "";
            var noOfDaysToAdd = qnty_less_data_updated; 
            var count = 0;
             
            while(count < noOfDaysToAdd ){
              
              endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
             
            
                
                
              
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {

                  
                   count++;
                }
           }
       
            const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];   
           
               var country_loc = localStorage.getItem("countryus");
           
              
                if(country_loc == "yes") {
                    if(varprice < 250 ){  
                        var newDate =  new Date(endDate.getTime() + (3 * 86400000));
                        var newDate2 = new Date(endDate.getTime() + (6 * 86400000));
                 
                      if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1;
                      var newddrange = newDate2.getDate();
                   } else{
                       var newdd = newDate.getDate();
                      var newddrange = newDate2.getDate();
                   }
                    var newmm = newDate.getMonth() + 1;
                    
                  if(qnty_less_data == 0){
                     var dayrange = weekday[newDate2.getDay()];
                      var day = weekday[newDate.getDay() -1];
                   } else{
                      var dayrange = weekday[newDate2.getDay()];
                      var day = weekday[newDate.getDay()];
                   }
                          
                    var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayrange+', '+monthNames[newDate2.getMonth()] + ' ' +newddrange;
                
                    } else{
                      var newDate =  new Date(endDate.getTime() + (2 * 86400000));
                        if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1;
                     
                   } else{
                       var newdd = newDate.getDate();
                      
                   }
                    var newmm = newDate.getMonth() + 1;
                    
                  if(qnty_less_data == 0){
                    
                      var day = weekday[newDate.getDay() -1];
                   } else{
                     
                      var day = weekday[newDate.getDay()];
                   }
                         
                     var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
                
  
                    }
                } else{

              
                 var newDate =  new Date(endDate.getTime()); 
               
                   if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1; 
                   } else{
                       var newdd = newDate.getDate();  
                   }
                   if(qnty_less_data == 0){
                    
                      var day = weekday[newDate.getDay() -1];
                   } else{
                  
                      var day = weekday[newDate.getDay()];
                   }
                      
                   var newmm = newDate.getMonth() + 1;
                  var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
                   
                 }
                 var text = document.createTextNode(finalDate).textContent;


              
            var text = document.createTextNode(finalDate).textContent;
            
              
           
              
            }


          var special_start_date = $('.special_start_date').text();
              var special_end_date = $('.special_end_date').text();

                  
          
              const startDatespecial = new Date(special_start_date.replace(/"/g, ""));
              
              const endDatespecial = new Date(special_end_date.replace(/"/g, ""));
               if(inventory_qty >= 1){
                 
                  let todaysom = new Date();
            let hhsom = todaysom.getHours(); 
            
             if(todaysom.getHours() > 23){
                var ddsom = todaysom.getDate() + 1 ;
           
               
             }  else{
              var ddsom = todaysom.getDate();
             }
            
            let mmsom = todaysom.getMonth() + 1;
            let yyyysom = todaysom.getFullYear();
            
            var startDatesom = yyyysom + '/' + mmsom + '/' + ddsom;
            startDatesom = new Date(startDatesom);
               
            var endDatesom = "", noOfDaysToAddsom = qnty_more_data, countsom = 0,  counttimesm =0;
            while(countsom < noOfDaysToAddsom){
              
            endDatesom = new Date(startDatesom.setDate(startDatesom.getDate() + 1)); 
              
          
              
              if (endDatesom.getDay() != 0 && endDatesom.getDay() != 6) {
                    countsom++;
                }
              
            }
               
              
          if (endDatesom >= startDatespecial && endDatesom <= endDatespecial) {
           
            
                var sp = 1 ;
          
            }else{
            
        
               var sp = 0 ;
           } 
                
               } else if(inventory_qty <= 0){

            let todayso = new Date();
            let hhso = todayso.getHours(); 
            
             if(todayso.getHours() > 23){
                var ddso = todayso.getDate() + 1 ;
           
               
             }  else{
              var ddso = todayso.getDate();
             }
            
            let mmso = todayso.getMonth() + 1;
            let yyyyso = todayso.getFullYear();
            
            var startDateso = yyyyso + '/' + mmso + '/' + ddso;
            startDateso = new Date(startDateso);
               
            var endDateso = "", noOfDaysToAddso = qnty_less_data, countso = 0,  counttimes =0;
            while(countso < noOfDaysToAddso){
              
            endDateso = new Date(startDateso.setDate(startDateso.getDate() + 1)); 
              
          
              
              if (endDateso.getDay() != 0 && endDateso.getDay() != 6) {
                    countso++;
                }
              
            } if (endDateso >= startDatespecial && endDateso <= endDatespecial) {
                   
                      
                       var sp = 1 ;
                  
                    }else{
                    
                   
                      var sp = 0 ;
                   } 
                }

              var dataType = $(this).data('type'); 
                 
              if(dataType == "Rings" || dataType == "Rings,Wedding Rings"  ){
               selectedVariantSku12 = selectedVariantSku12.split('-')[0];
               } 
             
              let  img_url = "https://dsv7iunirnrax.cloudfront.net/"+dataAttrValue+"/"+selectedVariantSku12+"-1.jpg";  

             
              if($(this).attr('data-template') == 'ready_to_ship_dyor'){
              var properties = {
                     'Delivery': text,
                    '_special': sp,
                    '_selectedImage': img_url,
                     'Sku': selectedVariantSku12
                     }
              }else{
               var properties =  {
                     'Delivery': text,
                    '_selectedImage': img_url,
                    '_special': sp,
                     'Sku': selectedVariantSku12
                     }
              }
            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: {
                    id: selectedVariantValue,
                    quantity: 1,
                  properties:properties
                },
                 success: function(data) {
                   $.ajax({
                       url: '/cart',
                       type: "GET",
                       dataType: "html",
                       success: function(data) {
                    
                         selectedVariantValue = "";
                           $("cart-drawer-items").html($(data).find('cart-drawer-items').html());
                           $('.tick_last_main_metal').hide();
                           $('.tick_jtpl_svg_addone_metal').show();
                           $('.tick_jtpl_svg_addingone_metal').hide();
                          
                         setTimeout(function() { 
                           $('.close_gemstone').click(); 
                           $('a.add_quick_btn_one_metal').show();
                          }, 2000);
                          
                           setTimeout(function() {
                               $('a.add_quick_btn_one_metal').show();
                               $('.caret_size_content').show();
                               $('.tick_jtpl_svg_addone_metal').hide();
                               $('.tick_jtpl_svg_addingone_metal').hide();
                               $('.tick_last_mainno').hide();
                               $('.jtpl_one_metalstep1').show();
                                
                           }, 4000);
              
              
                      
                          setTimeout(function() {
                           $('.drawer').css('visibility', 'visible');
                           $('.drawer').css('height', '100vh');
                           $('body').addClass('is-cart-active');
                           $('.bg-of-icon-sct').addClass('active-bg');
                        
                           $('.jtpl-custom-cart-drawer').removeClass('is-cart-close');
                           jQuery.getJSON('/cart.js', function(cart, textStatus) {
                               var getCount = cart.item_count;
                               if (getCount > 0) {
                                   $('button#CartDrawer-Checkout').removeAttr('disabled');
                                   $('.drawer').removeClass('is-empty');
                                   $('.drawer.is-empty .drawer__footer').css('display', 'block');
                                   $('.custom_cart.cart-count-bubble span[aria-hidden="true"]').text(getCount);
                                   $('.icon.icon-cart-empty span[aria-hidden="true"]').text(getCount);
                                   $('.cart-count-bubble span[aria-hidden="true"]').text(getCount);
                                   var getPrice = cart.total_price / 100;
              
                                   var getCurrency = $('body').attr('data-currency');
                                   var formattedPrice = Shopify.formatMoney(cart.total_price);
              
                                   var splitCurrency = formattedPrice.replace('$', '');
                                   var getCurrency = $('body').attr('data-currency');
                                   $('.totals__subtotal-value').text(getCurrency + splitCurrency);
              
                               }
                           });
                            }, 3000);  
                           setTimeout(function() {
                               if ($('body').hasClass('cart-hover')) {
              
                               } else {
                                   $('.drawer').css('height', '0vh');
                                   $('.drawer').css('visibility', 'hidden');
                                   $('.drawer').css('transition', 'visibility 0.5s ease-in-out, height 0.5s ease-in-out');
                                   $('body').removeClass('is-cart-active');
                                  $('.bg-of-icon-sct').removeClass('active-bg'); 
                                   $('.jtpl-custom-cart-drawer').addClass('is-cart-close');
              
                               }
                           }, 5000);
              
                       },
                   });
               }
            });

         });
      
        });
    
    
  
      
        


    
    });


   /*** quick add One Metal variant ****/
   

   






   
 $('body').on('click', '.carat_size_main.jtpl_step1', function() {
 
   
        $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step2').show();
        $(this).parents('.img_hover_content').find('.quick_add_btn a.add_quick_btn').hide();
        $(this).parents('.img_hover_content').find('.tick_last_main').hide();
        initializeSlick();
        $(this).hide();
    
    });








   


    //$(".jtpl-noMetavarant-list2").click(function() {
       $('body').on('click', '.jtpl-noMetavarant-list2', function() {

        $(this).parents('.caret_size_content').find('.jtpl_no_metalstep3').css('display', 'block');
        $(this).parents('.caret_size_content').find('.jtpl_no_metalstep2').css('display', 'none');
 if ($('.jtpl_no_metalvariant3').hasClass('slick-initialized')) {
  $('.jtpl_no_metalvariant3').slick('unslick');
        }
        $('.jtpl_no_metalvariant3').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
        });

    });






   // $(".jtpl_no_metalvariant1 .jtpl-noMetalvarant-list1").click(function() {
      $('body').on('click', '.jtpl_no_metalvariant1 .jtpl-noMetalvarant-list1', function() {
        $(this).parents('.jtpl_no_metalvariantt1').hide();
        $(this).parents('.caret_size_content').find(".jtpl_no_metalstep2").show();
        $(this).parents('.caret_size_content').find(".metal_name2").show();
        $(this).parents('.caret_size_content').find(".metal_name1").hide();
    });

   // $(".jtpl_no_metalvariant2 .jtpl-noMetalvarant-list2").click(function() {
    $('body').on('click', '.jtpl_no_metalvariant2 .jtpl-noMetalvarant-list2', function() {
        $(this).parents('.jtpl_no_metalvariant2').hide();
        //$(this).parents('.caret_size_content').find(".tick_last_mainno").show();
        $(this).parents('.caret_size_content').find(".metal_name1").hide();
        $(this).parents('.caret_size_content').find(".metal_name2").hide();
        $(this).parents('.caret_size_content').find(".metal_name3").hide();
        setTimeout(function() {



            $('a.add_quick_btn').show();
            $("a.add_quick_btn").mouseover(function() {
                $('.jtpl_variant1').show();
                $('.metal_name1').show();
            });
            //$('.tick_last_mainno').hide();
        }, 2000);


    });


  

    
     $('body').on('click', '.add_quick_btn_metal', function() {
     
    var weight =  $(this).attr('data-caratweight');
    var $this = $(this);   
         $(this).hide();
        
        $(this).closest('.img_hover_content').find('.tick_last_main_metal').show();
        $(this).closest('.img_hover_content').find('.tick_last_mainno').show();
        $(this).closest('.img_hover_content').find('.tick_jtpl_svg_addingno').css('display','flex');
    
        

        var dataAttrValue = $(this).data('attr');
        var selectedAltText = '';

        const variantElements = $(this).parents('.grid__item').find('.jtpl-pro-variant-cstm');

        variantElements.each(function() {
            var variantElement = $(this);
            var variantDataAttr = variantElement.data('attr');
         

            if (variantDataAttr === dataAttrValue) {


                var variantDiv = variantElement.find('.jtpl_selected');


                if (variantDiv.hasClass('jtpl_selected')) {

                    selectedAltText = variantDiv.attr('alt');
                    return;
                }
            }
        });


        if (selectedAltText) {

            const variantElements1 = $('.cstm-hide-select');
            let selectedOptionValue;
              let selectedskuValue;
            let selectedClassValue;
            variantElements1.each(function() {
                const variantElement1 = $(this);
                const variantDataAttr1 = variantElement1.data('attr');

                if (variantDataAttr1 === dataAttrValue) {

                    variantElement1.find('option').each(function() {
                        const optionText = $(this).text();

                        if (optionText === selectedAltText) {

                            selectedOptionValue = $(this).val();
                            selectedskuValue = $(this).data('sku');
                            selectedClassValue = $(this).attr('class');
                            return false;
                        }
                    });


                }
            });

         

       
          
          let productitems = [];
                productitems.push({
                    'vid': selectedOptionValue,
                    'pid': dataAttrValue
                }); 

                fetch('https://truesaniti.com/truesanity/product_inventory.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ productData: productitems })
                })
                .then(response => response.json())
                .then(response =>{
                   const txt = response;
          
                  const obj = JSON.parse(txt);
                
                  const inventory_qty = obj.inventory_qty; 
                  const qntymore = obj.quantity_more_than_1_ship_time;
                  const qntyless = obj.quantity_less_than_1_ship_time;
                  const varprice = obj.price;


            var skipDates = $('.skipDatesMeta').text();
            var qnty_more_data_meta = $('.qnty_more_data_meta').text();
            var qnty_less_data_meta = $('.qnty_less_data_meta').text(); 
           
            if(qntymore == undefined){
               var qnty_more_data = qnty_more_data_meta;
              } else{
              var qnty_more_data = qntymore;
             
             }  
            if(qntyless == undefined){
               var qnty_less_data = qnty_less_data_meta;
              } else{
              var qnty_less_data = qntyless;
                    
             } 
         

            if(inventory_qty >= 1){
              if(qnty_more_data == 0){
                 qnty_more_data_updated = qnty_more_data + 1;
               } else{
                 qnty_more_data_updated = qnty_more_data;
               }
             const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
            ];
             
            let today = new Date();
            const pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
            let hh = new Date(pstDate).getHours();
              
            
            
             if(hh > 15){
                var dd = today.getDate() + 1 ;
               }  else{
              var dd = today.getDate();
             }
            
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            
            var startDate = yyyy + '/' + mm + '/' + dd;
            startDate = new Date(startDate);
               
            var endDate = "";
            var noOfDaysToAdd = qnty_more_data_updated;
            var count = 0;
            var countabc = 0;
            var counttimes =0;
            while(count < noOfDaysToAdd){
              
            endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
              
           if (skipDates.includes(endDate.toISOString().substring(0, 10))) {
                continue;
              }
              
              
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {
                   
                  count++;
                }
              
            }
          
            
            const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];   
             var country_loc = localStorage.getItem("countryus");
           
              
                if(country_loc == "yes") {
                    if(varprice < 250 ){  
                        var newDate =  new Date(endDate.getTime() + (3 * 86400000));
                        var newDate2 = new Date(endDate.getTime() + (6 * 86400000));
                      if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1;
                      var newddrange = newDate2.getDate();
                   } else{
                       var newdd = newDate.getDate();
                      var newddrange = newDate2.getDate();
                   }
                    var newmm = newDate.getMonth() + 1;
                    
                  if(qnty_less_data == 0){
                     var dayrange = weekday[newDate2.getDay()];
                      var day = weekday[newDate.getDay() -1];
                   } else{
                      var dayrange = weekday[newDate2.getDay()];
                      var day = weekday[newDate.getDay()];
                   }
                          
                    var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayrange+', '+monthNames[newDate2.getMonth()] + ' ' +newddrange;
                
                    } else{
                      var newDate =  new Date(endDate.getTime() + (2 * 86400000));
                        if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1;
                     
                   } else{
                       var newdd = newDate.getDate();
                      
                   }
                    var newmm = newDate.getMonth() + 1;
                    
                  if(qnty_less_data == 0){
                    
                      var day = weekday[newDate.getDay() -1];
                   } else{
                     
                      var day = weekday[newDate.getDay()];
                   }
                         
                     var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
                
  
                    }
                  } else{

              
                   var newDate =  new Date(endDate.getTime()); 
                   if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1; 
                   } else{
                       var newdd = newDate.getDate();  
                   }
                   if(qnty_less_data == 0){
                    
                      var day = weekday[newDate.getDay() -1];
                   } else{
                  
                      var day = weekday[newDate.getDay()];
                   }
                      
                   var newmm = newDate.getMonth() + 1;
                  var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
                   
                 }  
             
            var text = document.createTextNode(finalDate).textContent;
            
            
             
            } else if(inventory_qty < 1){
               if(qnty_less_data == 0){
                 qnty_less_data_updated = qnty_less_data + 1;
               } else{
                 qnty_less_data_updated = qnty_less_data;
               }
              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
            ];
            
             let today = new Date();
            const pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
            let hh = new Date(pstDate).getHours();
              
           
            
             if(hh > 15){
                var dd = today.getDate() + 1 ;
               }  else{
              var dd = today.getDate();
             }
            
            let mm = today.getMonth() + 1;
            let yyyy = today.getFullYear();
            
            var startDate = yyyy + '/' + mm + '/' + dd;
            startDate = new Date(startDate);
               
            var endDate = "";
            var noOfDaysToAdd = qnty_less_data_updated; 
            var count = 0;
             
            while(count < noOfDaysToAdd ){
              
              endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
             
            
                
                
              
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {

                  
                   count++;
                }
           }
       
            const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];   
           
               var country_loc = localStorage.getItem("countryus");
           
              
                if(country_loc == "yes") {
                    if(varprice < 250 ){  
                        var newDate =  new Date(endDate.getTime() + (3 * 86400000));
                        var newDate2 = new Date(endDate.getTime() + (6 * 86400000));
                 
                      if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1;
                      var newddrange = newDate2.getDate();
                   } else{
                       var newdd = newDate.getDate();
                      var newddrange = newDate2.getDate();
                   }
                    var newmm = newDate.getMonth() + 1;
                    
                  if(qnty_less_data == 0){
                     var dayrange = weekday[newDate2.getDay()];
                      var day = weekday[newDate.getDay() -1];
                   } else{
                      var dayrange = weekday[newDate2.getDay()];
                      var day = weekday[newDate.getDay()];
                   }
                          
                    var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayrange+', '+monthNames[newDate2.getMonth()] + ' ' +newddrange;
                
                    } else{
                      var newDate =  new Date(endDate.getTime() + (2 * 86400000));
                        if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1;
                     
                   } else{
                       var newdd = newDate.getDate();
                      
                   }
                    var newmm = newDate.getMonth() + 1;
                    
                  if(qnty_less_data == 0){
                    
                      var day = weekday[newDate.getDay() -1];
                   } else{
                     
                      var day = weekday[newDate.getDay()];
                   }
                         
                     var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
                
  
                    }
                } else{

              
                 var newDate =  new Date(endDate.getTime()); 
                  
                   if(qnty_less_data == 0){
                      var newdd = newDate.getDate()- 1; 
                   } else{
                       var newdd = newDate.getDate();  
                   }
                   if(qnty_less_data == 0){
                    
                      var day = weekday[newDate.getDay() -1];
                   } else{
                  
                      var day = weekday[newDate.getDay()];
                   }
                      
                   var newmm = newDate.getMonth() + 1;
                  var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
                   
                 }
                 var text = document.createTextNode(finalDate).textContent;


              
            var text = document.createTextNode(finalDate).textContent;
            
              
           
              
            }




              var special_start_date = $('.special_start_date').text();
              var special_end_date = $('.special_end_date').text();

                  
          
              const startDatespecial = new Date(special_start_date.replace(/"/g, ""));
              
              const endDatespecial = new Date(special_end_date.replace(/"/g, ""));
               if(inventory_qty >= 1){
                 
                  let todaysom = new Date();
            let hhsom = todaysom.getHours(); 
            
             if(todaysom.getHours() > 23){
                var ddsom = todaysom.getDate() + 1 ;
           
               
             }  else{
              var ddsom = todaysom.getDate();
             }
            
            let mmsom = todaysom.getMonth() + 1;
            let yyyysom = todaysom.getFullYear();
            
            var startDatesom = yyyysom + '/' + mmsom + '/' + ddsom;
            startDatesom = new Date(startDatesom);
               
            var endDatesom = "", noOfDaysToAddsom = qnty_more_data, countsom = 0,  counttimesm =0;
            while(countsom < noOfDaysToAddsom){
              
            endDatesom = new Date(startDatesom.setDate(startDatesom.getDate() + 1)); 
              
          
              
              if (endDatesom.getDay() != 0 && endDatesom.getDay() != 6) {
                    countsom++;
                }
              
            }
               
              
          if (endDatesom >= startDatespecial && endDatesom <= endDatespecial) {
           
            
                var sp = 1 ;
          
            }else{
            
        
               var sp = 0 ;
           } 
                
               } else if(inventory_qty <= 0){

            let todayso = new Date();
            let hhso = todayso.getHours(); 
            
             if(todayso.getHours() > 23){
                var ddso = todayso.getDate() + 1 ;
           
               
             }  else{
              var ddso = todayso.getDate();
             }
            
            let mmso = todayso.getMonth() + 1;
            let yyyyso = todayso.getFullYear();
            
            var startDateso = yyyyso + '/' + mmso + '/' + ddso;
            startDateso = new Date(startDateso);
               
            var endDateso = "", noOfDaysToAddso = qnty_less_data, countso = 0,  counttimes =0;
            while(countso < noOfDaysToAddso){
              
            endDateso = new Date(startDateso.setDate(startDateso.getDate() + 1)); 
              
          
              
              if (endDateso.getDay() != 0 && endDateso.getDay() != 6) {
                    countso++;
                }
              
            }
               
             
                  if (endDateso >= startDatespecial && endDateso <= endDatespecial) {
                   
                      
                       var sp = 1 ;
                  
                    }else{
                    
                   
                      var sp = 0 ;
                   } 
                }

               
       
             let  img_url = "https://dsv7iunirnrax.cloudfront.net/"+dataAttrValue+"/"+selectedskuValue+"-1.jpg"
                
            // $('.slider.slider-products,.slidergem.slider-productsgem').each(function() {
              // const optionText8 = $(this).data('attr');
               
              // if(optionText8 == dataAttrValue){
                
              // img_url = $(this).find('#front').attr('src').replace('&width=500','');
              //  return true;
              // }
              
              // }); 

                $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: {
                    id: selectedOptionValue,
                    quantity: 1,
                     properties: {
                      'Delivery': selectedClassValue,
                      '_selectedImage': img_url,
                      'Sku':selectedskuValue,
                       '_caratWeight':weight
                     }
                },
                success: function(response) {
                  
                    $.ajax({
                    url: '/cart',
                    type: "GET",
                    dataType: "html",
                    success: function(data) {
                    

                      $('.cart-count-bubble').removeClass('product-added');
                         $('.tick_jtpl_svg_adding.tick_jtpl_svg_addingno').hide();
                         $('.tick_jtpl_svg_add.tick_jtpl_svg_addno').css('display','flex'); 
                      setTimeout(function() { $('.close_gemstone').click(); }, 1000);
                       // if (window.innerWidth < 768) {
                       //    setTimeout(() => window.location.href = '/cart', 1500);
                       //    } 
                  setTimeout(function() {
                      $("cart-drawer-items").html($(data).find('cart-drawer-items').html());
                       $('.drawer').css('visibility','visible');
                       $('.drawer').css('height','100vh');
                     var bubbleValue = $('.cart-count-bubble:first span[aria-hidden="true"]').text();
                        var convertInt = parseFloat(bubbleValue);
                        var addOne = convertInt + 1;
                        
                            //$('.cart-count-bubble span[aria-hidden="true"]').text(addOne);
                            $('.cart-count-bubble').addClass('product-added');
                        }, 2000);
                     
                      
                        

                       
                        setTimeout(function() {
                          
                            $('button#CartDrawer-Checkout').removeAttr('disabled');
                          
                     



                    $('.bg-of-icon-sct').addClass('active-bg'); 
                    $('body').addClass('is-cart-active')
                    $('.jtpl-custom-cart-drawer').removeClass('is-cart-close');
                    jQuery.getJSON('/cart.js', function (cart, textStatus) {
                  var getCount = cart.item_count;
                      if(getCount > 0 ){
                  $('.drawer').removeClass('is-empty');
                        $('button#CartDrawer-Checkout').removeAttr('disabled');
                         $('.drawer.is-empty .drawer__footer').css('display','block');
                        $('.custom_cart.cart-count-bubble span[aria-hidden="true"]').text(getCount);
                        $('.icon.icon-cart-empty span[aria-hidden="true"]').text(getCount);
                       $('.cart-count-bubble span[aria-hidden="true"]').text(getCount);
                         var getPrice = cart.total_price / 100;
                
                        //var formattedPrice = Shopify.formatMoney(cart.total_price);
                  //alert(formattedPrice);
                    // var splitCurrency = formattedPrice.replace('$','');
                  //alert(splitCurrency);
                  //$('.totals__subtotal-value').text(getPrice);
                        var getCurrency = $('body').attr('data-currency');
                        
                  $('.totals__subtotal-value').text(getCurrency + getPrice);
                  }
                 });
                     }, 2000);
                          
                     setTimeout(function() {
                    $this.closest('.img_hover_content').find('.tick_jtpl_svg_add.tick_jtpl_svg_addno').hide();
                   $this.closest('.img_hover_content').find('.add_quick_btn_metal').show();
                    $this.closest('.img_hover_content').find('.tick_last_main_metal').hide();
                      if ($('body').hasClass('cart-hover')) {
                            
                          } else {
                          $('.drawer').css('height','0vh');
                          $('.drawer').css('visibility','hidden');
                          $('.drawer').css('transition','visibility 0.5s ease-in-out, height 0.5s ease-in-out');
                          $('body').removeClass('is-cart-active');
                        $('.bg-of-icon-sct').removeClass('active-bg'); 
                        $('.jtpl-custom-cart-drawer').addClass('is-cart-close');
                          }
                       }, 5000);
                  },
                });

                }
            });
                  
                 
               })

          
       
            


        } else {
            $('.metal_select_text').show();
        }

    });


$(document).on("click",".jtpl-variant-img-new",function() {
var dataAttrValue = $(this).data('attr');
var selectedAltText = $(this).attr('alt');
 const variantElements = $('.jtpl-pro-variant-cstm');
         variantElements.each(function() {
            var variantElement = $(this);
            var variantDataAttr = variantElement.data('attr');
          if (variantDataAttr === dataAttrValue) {
             $(this).find('.jtpl-variant-img-old').removeClass('jtpl_selected');
                 
                   $(this).find('.jtpl-variant-img').each(function() {
              if ($(this).attr('alt') === selectedAltText ) {
             
                    $(this).addClass('jtpl_selected'); 
                  
                }
               
               }); 
                
            }
           
        });
  
  }); 
  /** Metal hover change image **/

  $(document).on({
     mouseenter: function() {
   
       var _this =this;
       var dataAttrValue = $(this).data('attr');
       var selectedAltText = $(this).attr('alt');
       var metal_handle = selectedAltText.toLowerCase().replace(/ /g,"-");
       var dataMetal = selectedAltText.toLowerCase().replace(/ /g,"");;     
    },
    mouseleave: function() {
   
         var _this =this;
         var selected_variant = $(this).parents('.jtpl-pro-variant-cstm,.jtpl-pro-variant-cstm-popup,.jtpl-pro-variant-cstm-gem').find('.jtpl-variant-img.jtpl_selected')
        
           
        
    },

}, ".jtpl-variant-img-recent");




  
  $(document).on({
     mouseenter: function() {
   
        var _this =this;
       var wizardInfo_1  = JSON.parse(localStorage.getItem("wizardInfo"));
        if($('body.page-dyor-settings-gemstone').length >0){
        var gemstone_wizard = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
        }
        if(gemstone_wizard != null){
        var gemstone_name =  $('body').attr('gemstone-title').replace(/\s+/g, '-').replaceAll('.', '-').toLowerCase();
        }
        var dataType = $(this).data('type');
        var dataAttrValue = $(this).data('attr');
        var selectedAltText = $(this).attr('alt');
        var metal_handle = selectedAltText.toLowerCase().replace(/ /g,"-");
        var dataAttrSelectImg = $(this).data('select');
        var dataAttrSelectIndex = $(this).data('index');
        var dataDyor = $(this).data('dyor');
        var dataShape = $(this).data('shape').toLowerCase();
        if(window.location.href.indexOf('dyor-diamond-settings')>-1){
        if(wizardInfo_1 != null){
          if(wizardInfo_1.stone_shape != null){
            dataShape = wizardInfo_1.stone_shape.toLowerCase();
          }
        }
        }
        var dataMetal = $(this).data('metal');
        var dataCarat = $(this).data('caratdyor');
       if(dataCarat == ''){
         dataCarat = 1;
       }
       
        var dataSku = $(this).data('sku').split('-')[0];
         var searchPAgedataSku = $(this).data('sku');
        var dataNewmetal = $(this).data('newmetal');
     
            var dataCarat = $(this).attr('data-carat');
            var dataQlty = $(this).data('quality');
            if (dataCarat == "" && dataQlty == "") {
          
            //var get_comboVar = selectedAltText;
           if (dataAttrSelectImg == ""){
               var get_comboVar = selectedAltText;
            } else{
               var get_comboVar = selectedAltText;
            }
            var get_combo = selectedAltText;
          
            } else if(dataQlty != "" && dataCarat == ""){
            if (dataAttrSelectImg == ""){
               var get_comboVar = selectedAltText;
            } else{
               var get_comboVar = selectedAltText;
            }
          
           if(dataAttrSelectIndex == "1"){
             var get_combo =  selectedAltText;
           } else{
             var get_combo =  dataQlty + ' / ' + selectedAltText;
           }
          }  else if(dataQlty == "" && dataCarat != ""){
            if (dataAttrSelectImg == ""){
               var get_comboVar = selectedAltText;
            } else{
               var get_comboVar = selectedAltText;
            }
            if(dataAttrSelectIndex == "1"){
              var get_combo =  selectedAltText+ ' / ' +dataCarat ;
           } else{
             var get_combo =  dataCarat + ' / ' + selectedAltText;
           }
        } else {
            if (dataAttrSelectImg == ""){
            var get_comboVar = selectedAltText;
              } else{
                 var get_comboVar = selectedAltText;
            }
            if(dataAttrSelectIndex == "1"){
              var get_combo =  selectedAltText + ' / ' + dataQlty + ' / ' + dataCarat;
           } else if(dataAttrSelectIndex == "2"){
            var get_combo =  selectedCaratQuality + ' / ' + selectedAltText + ' / ' + dataCarat;
           } else{
             var get_combo =  selectedCaratQuality + ' / ' + dataCarat + ' / ' + selectedAltText; 
           }
        }
      var combovarinat = get_combo;
        if(dataDyor == "1"){
          var dataCarat = $(this).data('caratdyor');
           if(dataCarat == ''){
             dataCarat = 1;
           }
                if (window.location.pathname.indexOf('/search') > -1) {
                var imgnew111 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+searchPAgedataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-1.jpg';
                var imgnew222 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+searchPAgedataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-2.jpg';
        if($('.jtpl-card-image-update_' + dataAttrValue).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-1').length > 0){
               var imgnew111 = $('.jtpl-card-image-update_' + dataAttrValue).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-1').attr('data-image')
            }
            checkImageExists(imgnew111, function(exists) {
                if (exists) {
                  $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('data-src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('srcset',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('data-src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('srcset',imgnew111);

                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('data-src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('srcset',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('data-src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('srcset',imgnew222);

                        }
                  });
              }else{
                    var imgnew111 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-1.jpg';
          var imgnew222 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-2.jpg';
           if($('.jtpl-card-image-update_' + dataAttrValue).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-1').length > 0){
               var imgnew111 = $('.jtpl-card-image-update_' + dataAttrValue).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-1').attr('data-image')
            }
      
            checkImageExists(imgnew111, function(exists) {
                if (exists) {
                  $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('data-src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('srcset',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('data-src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('srcset',imgnew111);

                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('data-src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('srcset',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('data-src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('srcset',imgnew222);

                        }
                  });

              }
         
          } else{   
           // $(this).parents('.grid__item').find(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVar);
           
          if(dataType == "Rings" || dataType == "Rings,Wedding Rings"  ){
             var selectedVariantSku = $(this).parents('.grid__item').find('.cstm-hide-select option[data-val="'+combovarinat+'"]').attr('data-sku').split('-')[0];
         } else{
              var selectedVariantSku = $(this).parents('.grid__item').find('.cstm-hide-select option[data-val="'+combovarinat+'"]').attr('data-sku');
          } 
             if (selectedVariantSku != "" ) {
     
            var imgnew = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
            var imgnew1 = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-2.jpg';
            
              checkImageExists(imgnew, function(exists) {
                 if (exists){
            
                     
                $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('src', imgnew);
                $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('data_src', imgnew);
                $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('srcset', imgnew);

                 $(_this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('src',imgnew);
                 $(_this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('data-src',imgnew);
                 $(_this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('srcset',imgnew);
                 $(_this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('src',imgnew1);
                 $(_this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('data-src',imgnew1);
                 $(_this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('srcset',imgnew1);
                        }
                  });
           
             // var price =  $(this).parents('.grid__item').find('.cstm-hide-select option[data-val="'+combovarinat+'"]').attr('data-price');
             // $(_this).parents('.grid__item').find('.price__regular .price-item--regular').text(price);  
               }
            
          } 
       var price =  $(this).parents('.grid__item').find('.cstm-hide-select option[data-val="'+combovarinat+'"]').attr('data-price');
      
             $(_this).parents('.grid__item').find('.price__regular .price-item--regular').text(price); 
           
    },
    mouseleave: function() {
   
       var _this =this;
      var selected_variant = $(this).parents('.jtpl-pro-variant-cstm,.jtpl-pro-variant-cstm-popup,.jtpl-pro-variant-cstm-gem').find('.jtpl-variant-img.jtpl_selected')
       var wizardInfo_1  = JSON.parse(localStorage.getItem("wizardInfo"));
       if($('body.page-dyor-settings-gemstone').length >0){
        var gemstone_wizard = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
       }
        if(gemstone_wizard != null){
          var gemstone_name = $('body').attr('gemstone-title').replace(/\s+/g, '-').replaceAll('.', '-').toLowerCase();
        }
        var dataType = $(this).data('type');
        var dataAttrValue = $(selected_variant).data('attr');
        var selectedAltText = $(selected_variant).attr('alt');
        var metal_handle = selectedAltText.toLowerCase().replace(/ /g,"-");
        var dataAttrSelectImg = $(selected_variant).data('select');
        var dataAttrSelectIndex = $(selected_variant).data('index');
        var dataDyor = $(selected_variant).data('dyor');
        var dataShape = $(selected_variant).data('shape');
        if(window.location.href.indexOf('dyor-diamond-settings')>-1){
        if(wizardInfo_1 != null){
          if(wizardInfo_1.stone_shape != null){
            dataShape = wizardInfo_1.stone_shape.toLowerCase();
          }
        }
        }
        var dataMetal = $(selected_variant).data('metal');
        var dataCarat = $(selected_variant).data('caratdyor');
        var dataSku = $(selected_variant).data('sku').split('-')[0];
       var searchPagedataSku = $(selected_variant).data('sku');
        var dataNewmetal = $(selected_variant).data('newmetal');
        
           var dataCarat = $(selected_variant).attr('data-carat');
            var dataQlty = $(selected_variant).data('quality');
            if (dataCarat == "" && dataQlty == "") {
          
            //var get_comboVar = selectedAltText;
           if (dataAttrSelectImg == ""){
               var get_comboVar = selectedAltText;
            } else{
               var get_comboVar = selectedAltText+' '+ dataAttrSelectImg;
            }
            var get_combo = selectedAltText;
          
            } else if(dataQlty != "" && dataCarat == ""){
            if (dataAttrSelectImg == ""){
               var get_comboVar = selectedAltText + ' | ' + dataQlty;
            } else{
               var get_comboVar = selectedAltText + ' | ' + dataQlty + dataAttrSelectImg;
            }
          
           if(dataAttrSelectIndex == "1"){
             var get_combo =  selectedAltText + ' / ' + dataQlty ;
           } else{
             var get_combo =  dataQlty + ' / ' + selectedAltText;
           }
          }  else if(dataQlty == "" && dataCarat != ""){
            if (dataAttrSelectImg == ""){
               var get_comboVar = selectedAltText + ' | ' + dataCarat;
            } else{
               var get_comboVar = selectedAltText + ' | ' + dataCarat + dataAttrSelectImg;
            }
            if(dataAttrSelectIndex == "1"){
              var get_combo =  selectedAltText+ ' / ' +dataCarat ;
           } else{
             var get_combo =  dataCarat + ' / ' + selectedAltText;
           }
        } else {
            if (dataAttrSelectImg == ""){
            var get_comboVar = selectedAltText + ' | ' + dataQlty + ' | ' + dataCarat;
              } else{
                 var get_comboVar = selectedAltText + ' | ' + dataQlty + ' | ' + dataCarat +dataAttrSelectImg;
            }
            if(dataAttrSelectIndex == "1"){
              var get_combo =  selectedAltText + ' / ' + dataQlty + ' / ' + dataCarat;
           } else if(dataAttrSelectIndex == "2"){
            var get_combo =  selectedCaratQuality + ' / ' + selectedAltText + ' / ' + dataCarat;
           } else{
             var get_combo =  selectedCaratQuality + ' / ' + dataCarat + ' / ' + selectedAltText; 
           }
        }


        var combovarinat = get_combo;
          if(dataDyor == "1"){
             if (window.location.pathname.indexOf('/search') > -1) {
                  var imgnew111 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+searchPagedataSku+'_'+dataShape+'_1_'+dataNewmetal+'-1.jpg';
          var imgnew222 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+searchPagedataSku+'_'+dataShape+'_1_'+dataNewmetal+'-2.jpg';

               
            checkImageExists(imgnew111, function(exists) {
                if (exists) {

                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('data-src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('srcset',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('data-src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('srcset',imgnew111);

                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('data-src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('srcset',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('data-src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('srcset',imgnew222);



                  
                // $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('src', imgnew111);
                // $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('data_src', imgnew111);
                // $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('srcset', imgnew111);

                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('src',imgnew111);
                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('data-src',imgnew111);
                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('srcset',imgnew111);
                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('src',imgnew222);
                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('data-src',imgnew222);
                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('srcset',imgnew222);
                        }
                  });
             }else{
           var imgnew111 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_1_'+dataNewmetal+'-1.jpg';
          var imgnew222 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_1_'+dataNewmetal+'-2.jpg';
          
      
            checkImageExists(imgnew111, function(exists) {
                if (exists) {

                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('data-src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('srcset',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('data-src',imgnew111);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('srcset',imgnew111);

                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('data-src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('srcset',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('data-src',imgnew222);
                $(_this).parents('.grid__item').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('srcset',imgnew222);



                  
                // $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('src', imgnew111);
                // $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('data_src', imgnew111);
                // $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('srcset', imgnew111);

                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('src',imgnew111);
                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('data-src',imgnew111);
                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('srcset',imgnew111);
                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('src',imgnew222);
                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('data-src',imgnew222);
                //  $(_this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('srcset',imgnew222);
                        }
                  });
             }
          } else{   
      
           // $(selected_variant).parents('.grid__item').find(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVar);
         
      
            
        if(dataType == "Rings" || dataType == "Rings,Wedding Rings"  ){
            var selectedVariantSku = $(selected_variant).parents('.grid__item').find('.cstm-hide-select option[data-val="'+combovarinat+'"]').attr('data-sku').split('-')[0];
         } else{
            var selectedVariantSku = $(selected_variant).parents('.grid__item').find('.cstm-hide-select option[data-val="'+combovarinat+'"]').attr('data-sku');
          } 
           if (selectedVariantSku != "" ) {
     
            var imgnew = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
            var imgnew1 = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-2.jpg';
         
              checkImageExists(imgnew, function(exists) {
                 if (exists){
              
                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('src',imgnew);
                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('data-src',imgnew);
                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('srcset',imgnew);

                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('src',imgnew1);
                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('data-src',imgnew1);
                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('srcset',imgnew1);
                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('src',imgnew1);
                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('data-src',imgnew1);
                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('srcset',imgnew1);
                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('src',imgnew);
                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('data-src',imgnew);
                  $(selected_variant).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('srcset',imgnew);

               
                 // $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('src',imgnew);
                 // $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('data-src',imgnew);
                 // $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('srcset',imgnew);
                 // $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('src',imgnew1);
                 // $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('data-src',imgnew1);
                 // $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('srcset',imgnew1);
                           }
                  });
               
             // var price =  $(selected_variant).parents('.grid__item').find('.cstm-hide-select option[data-val="'+combovarinat+'"]').attr('data-price');
             // $(selected_variant).parents('.grid__item').find('.price__regular .price-item--regular').text(price);  
               }
             
          }
      var price =  $(selected_variant).parents('.grid__item').find('.cstm-hide-select option[data-val="'+combovarinat+'"]').attr('data-price');
      $(selected_variant).parents('.grid__item').find('.price__regular .price-item--regular').text(price);
    },

}, ".jtpl-variant-img");






  
    /***Metal Image click event ***/

  /** Metal hover change image **/
//    $(document).on({
   
//     mouseleave: function() {
   
// setTimeout(function(){ 
//        var _this =this;
//       var selected_variant = $(this).find('.jtpl-variant-img.jtpl_selected')
//        var wizardInfo_1  = JSON.parse(localStorage.getItem("wizardInfo"));
     
//         var dataAttrValue = $(selected_variant).data('attr');
//         var selectedAltText = $(selected_variant).attr('alt');

//         var metal_handle = selectedAltText.toLowerCase().replace(/ /g,"-");
//         var dataAttrSelectImg = $(selected_variant).data('select');
//         var dataAttrSelectIndex = $(selected_variant).data('index');
//         var dataDyor = $(selected_variant).data('dyor');
//         var dataShape = $(selected_variant).data('shape');
      
//         var dataMetal = $(selected_variant).data('metal');
//         var dataCarat = $(selected_variant).data('caratdyor');
//         var dataSku = $(selected_variant).data('sku');
//         var dataNewmetal = $(selected_variant).data('newmetal');

//            var dataCarat = $(selected_variant).attr('data-carat');
//             var dataQlty = $(selected_variant).data('quality');
//             if (dataCarat == "" && dataQlty == "") {
          
//             //var get_comboVar = selectedAltText;
//            if (dataAttrSelectImg == ""){
//                var get_comboVar = selectedAltText;
//             } else{
//                var get_comboVar = selectedAltText+' '+ dataAttrSelectImg;
//             }
//             var get_combo = selectedAltText;
          
//             } else if(dataQlty != "" && dataCarat == ""){
//             if (dataAttrSelectImg == ""){
//                var get_comboVar = selectedAltText + ' | ' + dataQlty;
//             } else{
//                var get_comboVar = selectedAltText + ' | ' + dataQlty + dataAttrSelectImg;
//             }
          
//            if(dataAttrSelectIndex == "1"){
//              var get_combo =  selectedAltText + ' / ' + dataQlty ;
//            } else{
//              var get_combo =  dataQlty + ' / ' + selectedAltText;
//            }
//           }  else if(dataQlty == "" && dataCarat != ""){
//             if (dataAttrSelectImg == ""){
//                var get_comboVar = selectedAltText + ' | ' + dataCarat;
//             } else{
//                var get_comboVar = selectedAltText + ' | ' + dataCarat + dataAttrSelectImg;
//             }
//             if(dataAttrSelectIndex == "1"){
//               var get_combo =  selectedAltText+ ' / ' +dataCarat ;
//            } else{
//              var get_combo =  dataCarat + ' / ' + selectedAltText;
//            }
//         } else {
//             if (dataAttrSelectImg == ""){
//             var get_comboVar = selectedAltText + ' | ' + dataQlty + ' | ' + dataCarat;
//               } else{
//                  var get_comboVar = selectedAltText + ' | ' + dataQlty + ' | ' + dataCarat +dataAttrSelectImg;
//             }
//             if(dataAttrSelectIndex == "1"){
//               var get_combo =  selectedAltText + ' / ' + dataQlty + ' / ' + dataCarat;
//            } else if(dataAttrSelectIndex == "2"){
//             var get_combo =  selectedCaratQuality + ' / ' + selectedAltText + ' / ' + dataCarat;
//            } else{
//              var get_combo =  selectedCaratQuality + ' / ' + dataCarat + ' / ' + selectedAltText; 
//            }
//         }
//            // $(selected_variant).parents('.grid__item').find(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVar);
//            var combovarinat = get_combo;
//             var selectedVariantSku = $(selected_variant).parents('.grid__item').find('.cstm-hide-select option[data-val="'+combovarinat+'"]').attr('data-sku');

//            if (selectedVariantSku != "" ) {
          
//             var imgnew = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
//             var imgnew1 = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-2.jpg';
          
              
//                  $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('src', imgnew);
//                 $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('data_src', imgnew);
//                 $(_this).parents('.grid__item').find('.jtpl_sp.slick-active .main_slider_image #front').attr('srcset', imgnew);
    
                  
               
//                  $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('src',imgnew);
//                  $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('data-src',imgnew);
//                  $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('srcset',imgnew);
//                  $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('src',imgnew1);
//                  $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('data-src',imgnew1);
//                  $(selected_variant).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('srcset',imgnew1);
//                            }
                 
        
                
//     },500);     
//     },

// }, ".jtpl-pro-variant-cstm");

$(document).on("click",".jtpl-variant-img",function() {

        var wizardInfo_1  = JSON.parse(localStorage.getItem("wizardInfo"));
        if($('body.page-dyor-settings-gemstone').length >0){
        var gemstone_wizard = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
        }
        if(gemstone_wizard != null){
        var gemstone_name = $('body').attr('gemstone-title').replace(/\s+/g, '-').replaceAll('.', '-').toLowerCase();
        }
        var dataType = $(this).data('type');
        var dataAttrValue = $(this).data('attr');
        var selectedAltText =   $(this).attr('alt');
        var metal_handle = selectedAltText.toLowerCase().replace(/ /g,"-");
        var dataAttrSelectImg = $(this).data('select');
        var dataAttrSelectIndex = $(this).data('index');
        var dataDyor = $(this).data('dyor');
        var dataShape = $(this).data('shape');
        if(window.location.href.indexOf('dyor-diamond-settings')>-1){
        if(wizardInfo_1 != null){
          if(wizardInfo_1.stone_shape != null){
            dataShape = wizardInfo_1.stone_shape.toLowerCase();
          }
        }
        }
        var dataMetal = $(this).data('metal');
        var dataCarat = $(this).data('caratdyor');
        var dataSku = $(this).data('sku');
        var dataNewmetal = $(this).data('newmetal');
        $(this).parents('.grid__item').find('.main_slider_image,.main_slider_image_mobile').attr('data-meta-title',selectedAltText);
        var variantDataVal = '';
        var variantDataVal2 = '';
        var selectedcaratWeight = '';
        var selectedCaratQuality = '';
        var get_combo = '';
        const variantElements = $('.jtpl-pro-variant-cstm');

        variantElements.each(function() {
            var variantElement = $(this);
            var variantDataAttr = variantElement.data('attr');


            if (variantDataAttr === dataAttrValue) {
                var variantDiv = variantElement.find('.jtpl_selected');
                if (variantDiv.hasClass('jtpl_selected')) {
                    //selectedAltText = variantDiv.attr('alt');
                    selectedcaratWeight = variantDiv.data('carat');
                    selectedCaratQuality = variantDiv.data('quality');
                    return;
                }
            }
        });
        if (selectedCaratQuality == "" && selectedcaratWeight == "") {
          
            //var get_comboVar = selectedAltText;
           if (dataAttrSelectImg == ""){
               var get_comboVar = selectedAltText;
            } else{
               var get_comboVar = selectedAltText+' '+ dataAttrSelectImg;
            }
          
          
            var get_combo = selectedAltText;
          
            } else if(selectedCaratQuality != "" && selectedcaratWeight == ""){
            if (dataAttrSelectImg == ""){
               var get_comboVar = selectedAltText;
            } else{
               var get_comboVar = selectedAltText;
            }
          
           if(dataAttrSelectIndex == "1"){
             var get_combo =  selectedAltText + ' / ' + selectedCaratQuality ;
           } else{
             var get_combo =  selectedCaratQuality + ' / ' + selectedAltText;
           }
          }  else if(selectedCaratQuality == "" && selectedcaratWeight != ""){
            if (dataAttrSelectImg == ""){
               var get_comboVar = selectedAltText;
            } else{
               var get_comboVar = selectedAltText;
            }
            if(dataAttrSelectIndex == "1"){
              var get_combo =  selectedAltText+ ' / ' +selectedcaratWeight ;
           } else{
             var get_combo =  selectedcaratWeight + ' / ' + selectedAltText;
           }
        } else {
            if (dataAttrSelectImg == ""){
            var get_comboVar = selectedAltText;
              } else{
                 var get_comboVar = selectedAltText;
            }
            if(dataAttrSelectIndex == "1"){
              var get_combo =  selectedAltText + ' / ' + selectedCaratQuality + ' / ' + selectedcaratWeight;
           } else if(dataAttrSelectIndex == "2"){
            var get_combo =  selectedCaratQuality + ' / ' + selectedAltText + ' / ' + selectedcaratWeight;
           } else{
             var get_combo =  selectedCaratQuality + ' / ' + selectedcaratWeight + ' / ' + selectedAltText; 
           }   
        }
       
        $(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVar);
        
      
        let selectedVariantValue;
        let selectedVariantPrice;
        let selectedVariantSku;
        const variantElements1 = $('.cstm-hide-select');
        variantElements1.each(function() {
            const variantElement1 = $(this);
            const variantDataAttr1 = variantElement1.data('attr');
             
         
            if (variantDataAttr1 === dataAttrValue) {
  
                $(this).find('option').each(function() {
                  
                    let optionText = $(this).text();
                  
                    if (optionText.includes(selectedAltText)) {
                       
                        var optionData = optionText.split('/');
                        var data1 = optionData[0].trim(' ', '');
                        var data2 = optionData[0];
                       
                        var gte_select_val = '';
                        $('.jtpl-varant-list1').each(function() {
                            gte_select_val = $(this).attr('data-val');
                            var gte_select_attr = $(this).data('attr');
                            if (gte_select_val == data1) {
                                $(this).addClass('macthed-data');
                              }
                           setTimeout(function() {
                            $('.jtpl-varant-list1:not(.macthed-data)').hide();
                             
                             
                          }, 100);

                        });
                    }
                 
                    if (optionText === get_combo) {

                        selectedVariantValue = $(this).val();
                        selectedVariantPrice = $(this).data('price');
                       if(dataType == "Rings" || dataType == "Rings,Wedding Rings"  ){
                             selectedVariantSku = $(this).data('sku').split('-')[0];
                         } else{
                             selectedVariantSku = $(this).data('sku');
                          } 

                      
                        $("span#jtpl_price-item_" + dataAttrValue).text(selectedVariantPrice);
                       
                    }
                });
            }
        });

        if(dataDyor == "1"){

           var imgnew111 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-1.jpg';
           if($('.jtpl-card-image-update_' + dataAttrValue).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-1').length > 0){
               var imgnew111 = $('.jtpl-card-image-update_' + dataAttrValue).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-1').attr('data-image')
            }
      
            checkImageExists(imgnew111, function(exists) {
                if (exists) {
                            $('.jtpl-card-image-update_' + dataAttrValue).find('img').attr('src', imgnew111);
                            $('.jtpl-card-image-update_' + dataAttrValue).find('img').attr('srcset', imgnew111);
                        }
                  });
        const variantElements5 = $('.slider-jtpl-nav');
        variantElements5.each(function() {
            const variantElement5 = $(this);
            const variantDataAttr5 = variantElement5.data('attr');
            if (variantDataAttr5 === dataAttrValue) {

                var count = 1;
                $(this).find('.main_slider_image').each(function(index, element_main) {
 
              
                   var img_Alt22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-2.jpg';
                   if($(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-2').length > 0){
                    var img_Alt22 = $(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-2').attr('data-image')
                    }
                  if(dataAttrValue == 7431068811400){
                    if (count == 1) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'_1.jpg';
                        if($(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-1').length > 0){
                        var img22 = $(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-1').attr('data-image')
                        }
                    } else if (count == 2) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'_2.jpg';
                        if($(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-2').length > 0){
                        var img22 = $(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-2').attr('data-image')
                        }
                    }
                  }else{
                    if (count == 1) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-1.jpg';
                        if($(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-2').length > 0){
                        var img22 = $(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-1').attr('data-image')
                        }
                    } else if (count == 2) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-2.jpg';
                        if($(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-2').length > 0){
                        var img22 = $(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-2').attr('data-image')
                        }
                    }
                  }
                    count++;
                    checkImageExists(img22, function(exists) {
                        if (exists) {
                        $(element_main).find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('src',img22);
                        $(element_main).find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('data-src',img22);
                        $(element_main).find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('srcset',img22);
      
                        $(element_main).find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('src',img_Alt22);
                        $(element_main).find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('data-src',img_Alt22);
                        $(element_main).find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('srcset',img_Alt22);
                        $(element_main).find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('src',img_Alt22);
                        $(element_main).find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('data-src',img_Alt22);
                        $(element_main).find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('srcset',img_Alt22);
                        $(element_main).find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('src',img22);
                        $(element_main).find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('data-src',img22);
                        $(element_main).find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('srcset',img22);
                            // $(element_main).find('#front').attr('src', img22);
                            // $(element_main).find('#front').attr('data_src', img22);
                            // $(element_main).find('#front').attr('srcset', img22);
                            // $(element_main).find('#side').attr('src', img_Alt22);
                            // $(element_main).find('#side').attr('data_src', img_Alt22);
                            // $(element_main).find('#side').attr('srcset', img_Alt22);
                        }

                    });
                });
            }
        });

   const variantElements6 = $('.slider-jtpl-nav-mobile');
          
        variantElements6.each(function() {
            const variantElement6 = $(this);
            const variantDataAttr6 = variantElement6.data('attr');
            if (variantDataAttr6 === dataAttrValue) {
                var count = 1;
                var count1 = 1;
                var clone_len = $(this).find('.slick-slide:not(.slick-cloned)').length;
                $(this).find('.slick-slide:not(.slick-cloned)').each(function(index, element_main) {
                  var hype =false;
                  if(dataAttrValue == 7431068811400){
                     if (count == 1) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'_1.jpg';
                        if($(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-1').length > 0){
                        var img22 = $(this).parents('.grid__item').find('.gemstone_main_container[data-gemstone="'+gemstone_name+'"][data-metal="'+metal_handle+'"] span.gemstone_images.image-1').attr('data-image')
                        }
                    } else if (count == 2) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'_2.jpg';
                      
                     } 
                  }else{
                     if (count == 1) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-1.jpg';
                    } else if (count == 2) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-2.jpg';
                        
                    } 
                  }
                 
                    count++;
                    checkImageExists(img22, function(exists) {
                        if (exists) {
                            $(element_main).find('img').attr('src', img22);
                            $(element_main).find('img').attr('data_src', img22);
                            $(element_main).find('img').attr('srcset', img22);
                        }

                    });
                });
              $(this).find('.slick-slide.slick-cloned').each(function(index, element_main) {
                  var hype =false;
                  if(dataAttrValue == 7431068811400){
                     if(count1 == 1){
                    var img22 = `https://dsv7iunirnrax.cloudfront.net/${dataAttrValue}/dyor_setting_${dataSku}_${dataShape}_${dataCarat}_${dataNewmetal}_${clone_len+1}.jpg`;
                     }
                  }else{
                     if(count1 == 1){
                     var img22 = `https://dsv7iunirnrax.cloudfront.net/${dataAttrValue}/dyor_setting_${dataSku}_${dataShape}_${dataCarat}_${dataNewmetal}-${clone_len+1}.jpg`;
                     }
                   
                  }
                if(count1 == 2){
                  var img22 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'_1.jpg';
                }
                if(count1 == 2){
                  var img22 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-1.jpg';
                }
                console.log(img22);
                count1++;
                    checkImageExists(img22, function(exists) {
                        if (exists) {
                            $(element_main).find('img').attr('src', img22);
                            $(element_main).find('img').attr('data_src', img22);
                            $(element_main).find('img').attr('srcset', img22);
                        }

                    });
                });
            }
        });

           const variantElements6000 = $('.slider-jtpl-nav-mobile-new');
          
        variantElements6000.each(function() {
            const variantElement6000 = $(this);
            const variantDataAttr6000 = variantElement6000.data('attr');


            if (variantDataAttr6000 === dataAttrValue) {

                var count = 1;
               var count1 = 1;
                var clone_len = $(this).find('.slick-slide:not(.slick-cloned)').length;
                $(this).find('.slick-slide:not(.slick-cloned)').each(function(index, element_main) {
                  var hype =false;
                  if(dataAttrValue == 7431068811400){
                     if (count == 1) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'_1.jpg';
                    } else if (count == 2) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'_2.jpg';
                    } 
                  }else{
                     if (count == 1) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-1.jpg';
                    } else if (count == 2) {
                        var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-2.jpg';
                    }
                  }
                       
    
                    count++;
                    checkImageExists(img22, function(exists) {
                        if (exists) {
                            $(element_main).find('img').attr('src', img22);
                            $(element_main).find('img').attr('data_src', img22);
                            $(element_main).find('img').attr('srcset', img22);
                        }

                    });
                });
              $(this).find('.slick-slide.slick-cloned').each(function(index, element_main) {
                  var hype =false;
                  if(dataAttrValue == 7431068811400){
                     if(count1 == 1){
                    var img22 = `https://dsv7iunirnrax.cloudfront.net/${dataAttrValue}/dyor_setting_${dataSku}_${dataShape}_${dataCarat}_${dataNewmetal}_${clone_len+1}.jpg`;
                     }
                  }else{
                     if(count1 == 1){
                     var img22 = `https://dsv7iunirnrax.cloudfront.net/${dataAttrValue}/dyor_setting_${dataSku}_${dataShape}_${dataCarat}_${dataNewmetal}-${clone_len+1}.jpg`;
                     }
                   
                  }
                if(count1 == 2){
                  var img22 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'_1.jpg';
                }
                if(count1 == 2){
                  var img22 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-1.jpg';
                }
                console.log(img22);
                count1++;
                    checkImageExists(img22, function(exists) {
                        if (exists) {
                            $(element_main).find('img').attr('src', img22);
                            $(element_main).find('img').attr('data_src', img22);
                            $(element_main).find('img').attr('srcset', img22);
                        }

                    });
                });
            }
        });
          
        } else{
      if (selectedVariantSku != "" ) {
        if(dataType == "Rings" || dataType == "Rings,Wedding Rings"  ){
                 selectedVariantSku =   selectedVariantSku.split('-')[0];
            } 
            var imgnew = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
       
              checkImageExists(imgnew, function(exists) {
                        
                if (exists) {
                            $('.jtpl-card-image-update_' + dataAttrValue).find('img').attr('src', imgnew);
                            $('.jtpl-card-image-update_' + dataAttrValue).find('img').attr('srcset', imgnew);
                        }

                  });
        }
        const variantElements5 = $('.slider-jtpl-nav');
        variantElements5.each(function() {
            const variantElement5 = $(this);
            const variantDataAttr5 = variantElement5.data('attr');


            if (variantDataAttr5 === dataAttrValue) {
                 
                var counting = 1;
                $(this).find('.jtpl_sp_gem .main_slider_image').each(function(index, element_main) {
                  
                    var img_Alt = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
                  
                   
                        var img1 = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
                  
                        var img2 = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-2.jpg';
                   
                    counting++;
                   checkImageExists(img1, function(exists) {
                        if (exists) {
                            $(this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('src', img1);
                   $(this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('data_src', img1);
                   $(this).parents('.inventory_detail').find('.jtpl_gem_1 .main_slider_image img').attr('srcset', img1);
                        }
                   });
              
                 checkImageExists(img2, function(exists) {
                        if (exists) {
                   $(this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('src', img2);
                   $(this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('data_src', img2);
                   $(this).parents('.inventory_detail').find('.jtpl_gem_2 .main_slider_image img').attr('srcset', img2);
                       }
                   });     

                 
                });

              
                var count = 1;
                $(this).find('.jtpl_sp .main_slider_image').each(function(index, element_main) {

                    var img_Alt = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-2.jpg';
                  
                   
                        var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
                    
                       // var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
                       var img2 = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-2.jpg';
                   
                  
                    count++;
                //  $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img#front').attr('src',img);
                //  $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img#front').attr('data-src',img);
                //  $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img#front').attr('srcset',img);
                //  $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img#front').attr('src',img);
                //  $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img#front').attr('data-src',img);
                //  $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img#front').attr('srcset',img);

                // $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img#side').attr('src',img2);
                //  $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img#side').attr('data-src',img2);
                //  $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img#side').attr('srcset',img2);
                //  $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img#side').attr('src',img2);
                //  $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img#side').attr('data-src',img2);
                //  $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img#side').attr('srcset',img2);  
                
                  
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('src',img);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('data-src',img);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="0"] .main_slider_image img').attr('srcset',img);

                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('src',img2);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('data-src',img2);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="-1"] .main_slider_image img').attr('srcset',img2);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('src',img2);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('data-src',img2);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="1"] .main_slider_image img').attr('srcset',img2);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('src',img);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('data-src',img);
                 $(this).parents('.inventory_detail').find('.jtpl_sp[data-slick-index="2"] .main_slider_image img').attr('srcset',img);

                  
                    checkImageExists(img, function(exists) {
                        if (exists) {
                            // $(element_main).find('.jtpl_sp.slick-active #front').attr('src', img);
                            // $(element_main).find('.jtpl_sp.slick-active #front').attr('data_src', img);
                            // $(element_main).find('.jtpl_sp.slick-active #front').attr('srcset', img);
                            // $(element_main).find('.jtpl_sp.slick-active #side').attr('src', img_Alt);
                            // $(element_main).find('.jtpl_sp.slick-active #side').attr('data_src', img_Alt);
                            // $(element_main).find('.jtpl_sp.slick-active #side').attr('srcset', img_Alt);
                        }

                    });
                });

              
               var clone_no = $(this).find('.slick-slide:not(.slick-cloned)').length;
            var countttttt = 1;
             
              $(this).find('.slick-slide.slick-cloned').each(function(index, element_main) {
                  
                    if (countttttt == 1) {
                       var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-' + clone_no+ '.jpg';
                    
                    } else if (countttttt == 2) {
                       var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
                      
                    } 
                
                     
                    countttttt++;
                    checkImageExists(img, function(exists) {
                        if (exists) {
                            // $(element_main).find('img').attr('src', img);
                            // $(element_main).find('img').attr('data_src', img);
                            // $(element_main).find('img').attr('srcset', img);
                        }

                    });
                });
              
            } 

          
        });

    const variantElements8 = $('.slider-jtpl-nav-mobile');
          
        variantElements8.each(function() {
            const variantElement8 = $(this);
            const variantDataAttr8 = variantElement8.data('attr');


            if (variantDataAttr8 === dataAttrValue) {
                var _this = this
                var count = 1;
                var count1 =1
              var lenght_of_mobile =  $(this).find('.slick-slide:not(.slick-cloned)').length;
            
                $(this).find('.slick-slide:not(.slick-cloned)').each(function(index, element_main) {
                  
                    if (count == 1) {
                       var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
                    } else if (count == 2) {
                       var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-2.jpg';
                    }
                 
                    count++;
                    checkImageExists(img, function(exists) {
                        if (exists) {
                            // $(element_main).find('img').attr('src', img);
                            // $(element_main).find('img').attr('data_src', img22);
                            // $(element_main).find('img').attr('srcset', img22);
                        }

                    });
                });


              
             var clone_no = $(this).find('.slick-slide:not(.slick-cloned)').length;
              console.log(clone_no);
              $(this).find('.slick-slide.slick-cloned').each(function(index, element_main) {
                    if (count1 == 1) {
                       var img = `https://dsv7iunirnrax.cloudfront.net/' + ${dataAttrValue} + '/' + ${selectedVariantSku} + '-${clone_no}.jpg`;
                    } else if (count1 == 2) {
                       var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
                    } 
                     
                    count1++;
                console.log(img);
                    checkImageExists(img, function(exists) {
                        if (exists) {
                            // $(element_main).find('img').attr('src', img);
                            // $(element_main).find('img').attr('data_src', img22);
                            // $(element_main).find('img').attr('srcset', img22);
                        }

                    });
                });
            }
        });


          const variantElements8000 = $('.slider-jtpl-nav-mobile-new');
          
        variantElements8000.each(function() {
            const variantElement8000 = $(this);
            const variantDataAttr8000 = variantElement8000.data('attr');

            if (variantDataAttr8000 === dataAttrValue) {
                var _this = this
                var count = 1;
                var count1 =1
              var lenght_of_mobile =  $(this).find('.slick-slide:not(.slick-cloned)').length;
               
           
                $(this).find('.slick-slide:not(.slick-cloned)').each(function(index, element_main) {
                  
                    if (count == 1) {
                       var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
                    } else if (count == 2) {
                       var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-2.jpg';
                    } 
                    count++;
                    checkImageExists(img, function(exists) {
                        if (exists) {
                            // $(element_main).find('img').attr('src', img);
                            // $(element_main).find('img').attr('data_src', img22);
                            // $(element_main).find('img').attr('srcset', img22);
                        }

                    });
                });
             var clone_no = $(this).find('.slick-slide:not(.slick-cloned)').length;
              $(this).find('.slick-slide.slick-cloned').each(function(index, element_main) {
                  
                    if (count1 == 1) {
                       var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-' + clone_no+ '.jpg';
                    
                    } else if (count1 == 2) {
                       var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku + '-1.jpg';
                    } 
                     
                    count1++;
                    checkImageExists(img, function(exists) {
                        if (exists) {
                            // $(element_main).find('img').attr('src', img);
                            // $(element_main).find('img').attr('data_src', img);
                            // $(element_main).find('img').attr('srcset', img);
                        }

                    });
                });
            }
        });


          

        $(this).find('.slick-slide.slick-cloned').each(function(index, element_main) {
        
                  if(dataAttrValue == 7431068811400){
                     if(count1 == 1){
                    var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-7.jpg';
                     }
                  }else{
                     if(count1 == 1){
                     var img22 = 'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-7.jpg';
                     }
                   
                  }
                if(count1 == 2){
                  var img22 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'_1.jpg';
                }
                if(count1 == 2){
                  var img22 =  'https://dsv7iunirnrax.cloudfront.net/'+dataAttrValue+'/dyor_setting_'+dataSku+'_'+dataShape+'_'+dataCarat+'_'+dataNewmetal+'-1.jpg';
                }
                console.log(img22);
                count1++;
                    checkImageExists(img22, function(exists) {
                        if (exists) {
                            // $(element_main).find('img').attr('src', img22);
                            // $(element_main).find('img').attr('data_src', img22);
                            // $(element_main).find('img').attr('srcset', img22);
                        }

                    });
                });
      }
    });

    function checkImageExists(imageUrl, callback) {
        var img = new Image();
        img.onload = function() {

            // The image loaded successfully
            callback(true);
        };
        img.onerror = function() {
            // The image could not be loaded
            callback(false);
        };
        img.src = imageUrl;
    }

  
      /***Metal Image click event ***/
      
      /***Metal with variants ***/
  $('body').on('click', '.jtpl-varant-list1', function() {
  
   // $('.jtpl-varant-list1').on('click', function() {
        $('.jtpl-varant-list2').show();
        var dataAttrValue = $(this).data('attr');
        var dataVariant = $(this).data('var');
        var dataSelect2 = $(this).data('select');
        var dataSelectIndex3 = $(this).data('index');
        var variantDataVal = '';
        var variantDataVal2 = '';
        var selectedAltText = '';
        var selectedcaratWeight = '';
        var selectedCaratQuality = '';
        var get_combo = '';
        const variantElements = $('.jtpl-pro-variant-cstm');

        variantElements.each(function() {
            var variantElement = $(this);
            var variantDataAttr = variantElement.data('attr');


            if (variantDataAttr === dataAttrValue) {


                var variantDiv = variantElement.find('.jtpl_selected');


                if (variantDiv.hasClass('jtpl_selected')) {

                    selectedAltText = variantDiv.attr('alt');
                    selectedcaratWeight = variantDiv.data('carat');
                    selectedCaratQuality = variantDiv.data('quality');
                    return;
                }
            }
        });


        
            var variantDataVal = $(this).data('val');
        if(dataSelectIndex3 == "1"){
         var get_combo2 = selectedAltText + ' / ' + variantDataVal + ' / ' + selectedcaratWeight ;  
        } else if(dataSelectIndex3 == "2"){
           var get_combo2 = variantDataVal + ' / ' + selectedAltText + ' / ' + selectedcaratWeight;
        } else{
          var get_combo2 = variantDataVal + ' / ' + selectedcaratWeight + ' / ' + selectedAltText; 
        }
      
            var get_combo2 = variantDataVal + ' / ' + selectedcaratWeight + ' / ' + selectedAltText;
               if(dataSelect2 == ""){
                      var get_comboVarsecond = selectedAltText + ' | ' + variantDataVal + ' | ' + selectedcaratWeight;
                   }else{
                       var get_comboVarsecond = selectedAltText + ' | ' + variantDataVal + ' | ' + selectedcaratWeight+ dataSelect2;
                   }
            $(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVarsecond);
            const variantElements4 = $('.cstm-hide-select');
            let selectedVariantPrice4;
            let selectedVariantSku4;
            variantElements4.each(function() {
                const variantElement4 = $(this);
                const variantDataAttr4 = variantElement4.data('attr');

                if (variantDataAttr4 === dataAttrValue) {
                    let optionText4new;
                    variantElement4.find('option').each(function() {
                        const optionText4 = $(this).text();

                        if (optionText4.includes(selectedAltText)) {
                            optionText4new = optionText4;

                            if (optionText4new.includes(variantDataVal)) {

                                var secondVar = optionText4new.split('/');
                                var soption1 = secondVar[1].trim(' ', '');

                                var gte_select_val_second = '';
                                $('.jtpl-varant-list2').each(function() {
                                    gte_select_val_second = $(this).attr('data-val');
                                    var gte_select_attr_second = $(this).data('attr');
                                    if (gte_select_val_second === soption1) {

                                        $(this).addClass('second-macthed-data');
                                    }
                                    setTimeout(function() {

                                        $('.jtpl-varant-list2:not(.second-macthed-data)').hide();
                                    }, 100);
                                });

                            }
                        }
                        if (optionText4 === get_combo2) {

                            selectedVariantPrice4 = $(this).data('price');
                            selectedVariantSku4 = $(this).data('sku');
                            $("span#jtpl_price-item_" + dataAttrValue).text(selectedVariantPrice4);
                        }
                    });


                }
            });
            if (selectedVariantSku4 != "") {
           
                var imgnew = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku4 + '-1.jpg';
                checkImageExists(imgnew, function(exists) {
                        if (exists) {
                            $('.jtpl-card-image-update_' + dataAttrValue).find('img').attr('src', imgnew);
                        }

                  });
            }
            const variantElements6 = $('.slider-jtpl-nav');
            variantElements6.each(function() {
                const variantElement6 = $(this);
                const variantDataAttr6 = variantElement6.data('attr');

                if (variantDataAttr6 === dataAttrValue) {

                    var count = 1;
                    $(this).find('.main_slider_image').each(function(index, element_main) {

                        if (count == 1) {
                            var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku4 + '-2.jpg';
                        } else if (count == 2) {
                            var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku4 + '-1.jpg';
                        } 
                 
                        count++;
                        checkImageExists(img, function(exists) {
                            if (exists) {
                             $(element_main).find('img').attr('src', img);
                            }

                        });
                    });
                }
            });

            if(dataVariant == 1){
            $('body').on('click', '.jtpl-varant-list2', function() {
            
              initializeSlick3();
            $(this).parents('.img_hover_content').find('.addtoBag').hide();
                $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step3').show();
                $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step1').hide();
                $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step2').hide();
                var variantDataVal2 = $(this).data('val');
              if(dataSelectIndex3 == "1"){
                var get_combo = selectedAltTextvariantDataVal + ' / ' + variantDataVal + ' / ' + variantDataVal2 ;
                } else if(dataSelectIndex3 == "2"){
                  var get_combo = variantDataVal + ' / ' + selectedAltText + ' / ' + variantDataVal2;
                } else{
                   var get_combo = variantDataVal + ' / ' + variantDataVal2 + ' / ' + selectedAltText;
                }
              if(dataSelect2 == ""){
                      var get_comboVarThird = selectedAltText + ' | ' + variantDataVal + ' | ' + variantDataVal2;
                   }else{
                       var get_comboVarThird = selectedAltText + ' | ' + variantDataVal + ' | ' + variantDataVal2+ dataSelect2;
                   }
                $(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVarThird);

                const variantElements1 = $('.cstm-hide-select');
                let selectedVariantValue;
                let selectedVariantPrice5;
                let selectedVariantSku5;
                variantElements1.each(function() {
                    const variantElement1 = $(this);
                    const variantDataAttr1 = variantElement1.data('attr');

                    if (variantDataAttr1 === dataAttrValue) {

                        variantElement1.find('option').each(function() {
                            const optionText = $(this).text();
                           
                            if (optionText === get_combo) {

                                selectedVariantValue = $(this).val();
                                selectedVariantPrice5 = $(this).data('price');
                                selectedVariantSku5 = $(this).data('sku');
                                $("span#jtpl_price-item_" + dataAttrValue).text(selectedVariantPrice5);
                                return false;
                            }
                        });


                    }
                });
                if (selectedVariantSku5 != "") {
                 
                    var imgnew = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku5 + '-1.jpg';
                    checkImageExists(imgnew, function(exists) {
                        if (exists) {
                            $('.jtpl-card-image-update_' + dataAttrValue).find('img').attr('src', imgnew);
                        }

                  });
                }
                const variantElements7 = $('.slider-jtpl-nav');
                variantElements7.each(function() {
                    const variantElement7 = $(this);
                    const variantDataAttr7 = variantElement7.data('attr');

                    if (variantDataAttr7 === dataAttrValue) {

                        var count = 1;
                        $(this).find('.main_slider_image').each(function(index, element_main) {

                            if (count == 1) {
                                var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku5 + '-2.jpg';
                            } else if (count == 2) {
                                var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku5 + '-1.jpg';
                            } 
                            count++;
                            checkImageExists(img, function(exists) {
                                if (exists) {
                                    $(element_main).find('img').attr('src', img);
                                }

                            });
                        });
                    }
                });

              
            $('body').on('click', '.jtpl-varant-list3', function() {
                 $(this).parents('.img_hover_content').find('.addtoBag').show();
                $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step1').hide();
                $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step2').hide();
                $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step3').hide();
                 var variantDataVal3line = $(this).data('val');
             
                var get_comboVarThirdDataVal = selectedAltText + ' | ' + variantDataVal + ' | ' + variantDataVal2+ ' | '+variantDataVal3line;
               $(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVarThirdDataVal);
               $('body').on('click', '.addtoBag', function() {
                    $(this).hide();
                    $(this).parents('.img_hover_content').find('.tick_last_main').css('display', 'block');
                    $(this).parents('.img_hover_content').find('.quick_add_btn a.add_quick_btn').hide();
                    $(this).parents('.img_hover_content').find('.tick_jtpl_svg_adding').show();

                    $.ajax({
                        url: '/cart/add.js',
                        type: 'POST',
                        data: {
                            id: selectedVariantValue,
                            quantity: 1,
                            properties: {
                                      Size: variantDataVal3line,
                                     }
                        },
                        success: function(response) {
                            $('.tick_jtpl_svg_adding').hide();
                            $('.tick_jtpl_svg_add').show();
                            setTimeout(function() {
                                $('.tick_jtpl_svg_adding').hide();
                                $('.tick_jtpl_svg_add').hide();
                                $(this).parents('.img_hover_content').find('a.add_quick_btn').hide();
                               $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step1').show();
                            }, 4000);
                            $('.tick_last_main_metal').show();
                            //$('.quick_add_btn_metal').hide();
                            //document.getElementById('jtplstatus').textContent = 'Added';
                            setTimeout(function() {

                                $('.tick_last_main_metal').hide();
                               // $('.quick_add_btn_metal').show();
                            }, 2000);
                            setTimeout(function() {

                                $(".jtpl-custom-cart-drawer").load(location.href + " .cart-count-bubble");
                                $(".jtpl-custom-cart-drawer").load(location.href + " .drawer");
                                $(".jtpl-custom-cart-drawer-1").load(location.href + " .cart-count-bubble");
                                $(".jtpl-custom-cart-drawer-1").load(location.href + " .drawer");
                                var bubbleValue = $('.cart-count-bubble:first span[aria-hidden="true"]').text();
                                var convertInt = parseFloat(bubbleValue);
                                var addOne = convertInt + 1;
                                setTimeout(function() {
                                    $('.cart-count-bubble span[aria-hidden="true"]').text(addOne);
                                    $('.cart-count-bubble').addClass('product-added');
                                    setTimeout(function() {
                                        $('.cart-count-bubble').removeClass('product-added');
                                    }, 2000);

                                }, 1000);
                                setTimeout(function() {
                                    $('button#CartDrawer-Checkout').removeAttr('disabled');
                                }, 1000);
                            }, 500);

                        }
                    });
                });
            });

            });
            } else{
            
            $('body').on('click', '.jtpl-varant-list2', function() {

                $(this).parents('.img_hover_content').find('.addtoBag').show();
                $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step1').hide();
                $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step2').hide();
                $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step3').hide();
                var variantDataVal2 = $(this).data('val');
                var get_combo = variantDataVal + ' / ' + variantDataVal2 + ' / ' + selectedAltText;
                var get_comboVarThird = selectedAltText + ' | ' + variantDataVal + ' | ' + variantDataVal2;
                $(".select_var_content_" + dataAttrValue).text("Selected: " + get_comboVarThird);

                const variantElements1 = $('.cstm-hide-select');
                let selectedVariantValue;
                let selectedVariantPrice5;
                let selectedVariantSku5;
                variantElements1.each(function() {
                    const variantElement1 = $(this);
                    const variantDataAttr1 = variantElement1.data('attr');

                    if (variantDataAttr1 === dataAttrValue) {

                        variantElement1.find('option').each(function() {
                            const optionText = $(this).text();
                          
                            if (optionText === get_combo) {

                                selectedVariantValue = $(this).val();
                                selectedVariantPrice5 = $(this).data('price');
                                selectedVariantSku5 = $(this).data('sku');
                                $("span#jtpl_price-item_" + dataAttrValue).text(selectedVariantPrice5);
                                return false;
                            }
                        });
                    }
                });
                if (selectedVariantSku5 != "") {
                 
                    var imgnew = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku5 + '-1.jpg';
                    checkImageExists(imgnew, function(exists) {
                        if (exists) {
                            $('.jtpl-card-image-update_' + dataAttrValue).find('img').attr('src', imgnew);
                        }

                  });
                }
                const variantElements7 = $('.slider-jtpl-nav');
                variantElements7.each(function() {
                    const variantElement7 = $(this);
                    const variantDataAttr7 = variantElement7.data('attr');

                    if (variantDataAttr7 === dataAttrValue) {

                        var count = 1;
                        $(this).find('.main_slider_image').each(function(index, element_main) {

                            if (count == 1) {
                                var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku5 + '-2.jpg';
                            } else if (count == 2) {
                                var img = 'https://dsv7iunirnrax.cloudfront.net/' + dataAttrValue + '/' + selectedVariantSku5 + '-1.jpg';
                            }
                            count++;
                            checkImageExists(img, function(exists) {
                                if (exists) {
                                    $(element_main).find('img').attr('src', img);
                                }

                            });
                        });
                    }
                });
               $('body').on('click', '.addtoBag', function() {
                    $(this).hide();
                    $(this).parents('.img_hover_content').find('.tick_last_main').css('display', 'block');
                    $(this).parents('.img_hover_content').find('.quick_add_btn a.add_quick_btn').hide();
                    $(this).parents('.img_hover_content').find('.tick_jtpl_svg_adding').show();

                    $.ajax({
                        url: '/cart/add.js',
                        type: 'POST',
                        data: {
                            id: selectedVariantValue,
                            quantity: 1,
                        },
                        success: function(response) {
                            $('.tick_jtpl_svg_adding').hide();
                            $('.tick_jtpl_svg_add').show();
                            setTimeout(function() {
                                $('.tick_jtpl_svg_adding').hide();
                                $('.tick_jtpl_svg_add').hide();
                                  $(this).parents('.img_hover_content').find('a.add_quick_btn').hide();
                               $(this).parents('.img_hover_content').find('.carat_size_main.jtpl_step1').show();
                            }, 4000);
                            $('.tick_last_main_metal').show();
                            //$('.quick_add_btn_metal').hide();
                            //document.getElementById('jtplstatus').textContent = 'Added';
                            setTimeout(function() {

                                $('.tick_last_main_metal').hide();
                               // $('.quick_add_btn_metal').show();
                            }, 4000);
                            setTimeout(function() {

                                $(".jtpl-custom-cart-drawer").load(location.href + " .cart-count-bubble");
                                $(".jtpl-custom-cart-drawer").load(location.href + " .drawer");
                                $(".jtpl-custom-cart-drawer-1").load(location.href + " .cart-count-bubble");
                                $(".jtpl-custom-cart-drawer-1").load(location.href + " .drawer");
                                var bubbleValue = $('.cart-count-bubble:first span[aria-hidden="true"]').text();
                                var convertInt = parseFloat(bubbleValue);
                                var addOne = convertInt + 1;
                                setTimeout(function() {
                                    $('.cart-count-bubble span[aria-hidden="true"]').text(addOne);
                                    $('.cart-count-bubble').addClass('product-added');
                                    setTimeout(function() {
                                        $('.cart-count-bubble').removeClass('product-added');
                                    }, 2000);

                                }, 1000);
                                setTimeout(function() {
                                    $('button#CartDrawer-Checkout').removeAttr('disabled');
                                }, 1000);
                            }, 500);

                        }
                    });


                });
            });

          }
     });

      /***Metal with variants ***/

 /***no variants ***/
   // $('.add_quick_btn_no').on('click', function() {
       $('body').on('click', '.add_quick_btn_no', function() {
        ;
        var dataAttrValue = $(this).data('attr');
        $(this).parents('.quick_add_btn_metal').find('.tick_last_main').css('display', 'block');
        $(this).parents('.quick_add_btn_metal').find('.tick_jtpl_svg_adding').css('display', 'flex');
        $(this).hide();
        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            data: {
                id: dataAttrValue,
                quantity: 1,
            },
            success: function(response) {
                // setTimeout(() => window.location.reload(), 500);
                // $('.tick_last_main_metal').show(); 
                $('.tick_jtpl_svg_add').show();
                $('.tick_jtpl_svg_adding').hide();
                //$('.quick_add_btn_metal').hide();
                setTimeout(function() {
                    $('.add_quick_btn_no').show();
                    $('.tick_jtpl_svg_adding').hide();
                    $('.tick_jtpl_svg_add').hide();
                    //$('.tick_last_main_metal').hide(); 
                    // $('.quick_add_btn_metal').show();
                }, 4000);
                setTimeout(function() {
                    $(".jtpl-custom-cart-drawer").load(location.href + " .cart-count-bubble");
                    $(".jtpl-custom-cart-drawer").load(location.href + " .drawer");
                    $(".jtpl-custom-cart-drawer-1").load(location.href + " .cart-count-bubble");
                    $(".jtpl-custom-cart-drawer-1").load(location.href + " .drawer");
                    var bubbleValue = $('.cart-count-bubble:first span[aria-hidden="true"]').text();
                    var convertInt = parseFloat(bubbleValue);
                    var addOne = convertInt + 1;
                    setTimeout(function() {
                        $('.cart-count-bubble span[aria-hidden="true"]').text(addOne);
                        $('.cart-count-bubble').addClass('product-added');
                    }, 1000);
                    setTimeout(function() {
                        $('.cart-count-bubble').removeClass('product-added');
                    }, 2000);
                    setTimeout(function() {
                        $('button#CartDrawer-Checkout').removeAttr('disabled');
                    }, 1000);
                }, 500);

            }
        });



    });

/***18 DEC 2023 Collection quick add*****/
  
if(window.location.href.indexOf('products') >-1){
  localStorage.removeItem("setting_deliver_date");
}
if(window.location.href.indexOf('products') >-1){
 var ring_band =  JSON.parse(localStorage.getItem("ring_band_product"));
 var current_p = window.location.pathname.split('/products/')[1];
  if(ring_band != null){
    if(ring_band.band_and_ring_handle == current_p){
    }else{
      localStorage.removeItem("band_products");
      localStorage.removeItem("ring_band_product");
    }
  }
  else{
    localStorage.removeItem("band_products");
    localStorage.removeItem("ring_band_product");
  }
  
  }
$('.search_btn img').click(function(){
   var search_val = $(this).parents('.search-modal__form').find('.search__input3').val().length;
    if(search_val >0){
    $(this).parents('.search-modal__form').submit();
    }
});
$( window ). on( "load", function() {
var head = jQuery("#grid-img-diamond .img-diamond iframe"). contents(). find("head");
var css = '<style type="text/css">' +
'.buttons{display:none}; ' +
'</style>';
jQuery(head). append(css);
});

  
  $('.main_back_btn').click(function(){
    $(this).parents('.megaDrawer').find('input').prop('checked',false);
  });
  $('.start-with-pendant').click(function(e){
      localStorage.removeItem('wizardInfo_dyop')
  })

var get_web_url = window.location.href;
  if(get_web_url.indexOf('collections') >-1){
     $('#product-grid .grid__item').each(function(){
     var title = $(this).find('.jtpl-pro-variant-cstm .jtpl-variant-img.jtpl_selected').attr('alt');
     var selected_price = $(this).find('.cstm-hide-select option[data-val="'+title+'"]').attr('data-price'); 
     $(this).find('.price-item.price-item--regular').text(selected_price);
    })
  }
$(document).on('click','.collection-all-jewelry .grid__item, .collection-rings .grid__item, .collection-earrings .grid__item, .collection-necklaces-pendants .grid__item, .collection-bracelets .grid__item,.collection-studs  .grid__item,.page-t3-gemstone .grid__item',function(){
  var metal_name = $(this).find('.main_slider_image:first').attr('data-meta-title');
  var metal_shap = $(this).find('.main_slider_image:first').attr('data-shape');
  var pro_handle = $(this).find('.main_slider_image:first').attr('data-product-handle');

  metal_name1 =`${metal_name},${pro_handle}`;
  if(metal_name != '' ){
   localStorage.setItem("metal_name_nondyor", metal_name1);
  }
})


  
  $(document).on('click','.collection-dyor-diamond-settings .grid__item,.collection-necklaces-and-pendants .grid__item_shape,.collection-engagement-ring-settings-shape  .grid__item_shape,.page-dyor-settings-gemstone .grid__item_shape',function(){
  var metal_name = $(this).find('.main_slider_image:first').attr('data-meta-title');
  var metal_shap = $(this).find('.dyor_loop_img.jtpl_selected').attr('data-shapee');
  var pro_handle = $(this).find('.main_slider_image:first').attr('data-product-handle');
   metal_shap1 =`${metal_shap},${pro_handle}`; 
    
    if(metal_shap != ''){
  var diamond_img =  getDiamondLinesImgTableResults1(metal_shap);
  var wizardInfo_1  = JSON.parse(localStorage.getItem("wizardInfo"));
   if(wizardInfo_1 != null && get_web_url.indexOf('dyor-diamond-settings') > -1){
   var currnet_shap =  wizardInfo_1.stone_shape;
     if(currnet_shap = null){
     wizardInfo_1 = JSON.stringify(wizardInfo_1);
     localStorage.setItem("wizardInfo", wizardInfo_1);
     }else{
      localStorage.setItem("diamon_shape", metal_shap1);
     }
   }else{
      localStorage.setItem("diamon_shape", metal_shap1);
   }
  }
  metal_name1 =`${metal_name},${pro_handle}`;
  if(metal_name != '' ){
   localStorage.setItem("metal_name", metal_name1);
  }
})

  $(document).on('click','.page-dyor-settings-gemstone .grid__item_shape',function(){
   var metal_name = $(this).find('.main_slider_image:first').attr('data-meta-title');
   var metal_shap = $(this).find('.main_slider_image:first').attr('data-shape');
   var pro_handle = $(this).find('.main_slider_image:first').attr('data-product-handle');
   metal_shap1 =`${metal_shap},${pro_handle}`;
    if(metal_shap != ''){
    var diamond_img =  getDiamondLinesImgTableResults1(metal_shap);
    var wizardInfo_gemstone_1  = JSON.parse(localStorage.getItem("wizardInfo_gemstone"));
     if(wizardInfo_gemstone_1 != null && get_web_url.indexOf('/collections/engagement-ring-settings-with-gemstone') > -1){
     var currnet_shap =  wizardInfo_gemstone_1.gemstone_shape;
       if(currnet_shap = null){
     wizardInfo_gemstone_1 = JSON.stringify(wizardInfo_gemstone_1);
     localStorage.setItem("wizardInfo_gemstone", wizardInfo_gemstone_1);
     }else{
      localStorage.setItem("gemstone_shape", metal_shap1);
     }
     }else{
       localStorage.setItem("gemstone_shape", metal_shap1);
   }
  }
  metal_name1 =`${metal_name},${pro_handle}`;
  if(metal_name != '' ){
   localStorage.setItem("metal_gemstone", metal_name1);
    if(metal_shap != ''){
    var diamond_img =  getDiamondLinesImgTableResults1(metal_shap);
    var wizardInfo_gemstone_1  = JSON.parse(localStorage.getItem("wizardInfo_gemstone"));
     if(wizardInfo_gemstone_1 != null && get_web_url.indexOf('dyor-diamond-settings') > -1){
     var currnet_shap =  wizardInfo_gemstone_1.stone_shape;
       if(currnet_shap = null){
       wizardInfo_gemstone_1 = JSON.stringify(wizardInfo_gemstone_1);
       localStorage.setItem("wizardInfo_gemstone", wizardInfo_gemstone_1);
       }else{
        localStorage.setItem("gemstone_shape", metal_shap1);
       }
       }else{
        localStorage.setItem("gemstone_shape", metal_shap1);
       }
    }
  }
  }) 
  
  var metal_shap = localStorage.getItem("diamon_shape");
  var metal_product = localStorage.getItem("metal_name");
  if(metal_product != null){
 metal_product1 = metal_product.split(',')[0];
 metal_product_handle = metal_product.split(',')[1]
 if(metal_product1 != null || metal_product1 != undefined){
  if(window.location.href.indexOf(metal_product_handle)<0){
  localStorage.removeItem("metal_name");
  }
 }
 }else{
   localStorage.removeItem("metal_name");
 }
   if(metal_shap != null){
 metal_shap1 = metal_shap.split(',')[0];
 metal_product_handle = metal_shap.split(',')[1]
 if(metal_shap1 != null || metal_shap1 != undefined){
  if(window.location.href.indexOf(metal_product_handle)<0){
  localStorage.removeItem("diamon_shape");
  }
 }
 }else{
   localStorage.removeItem("diamon_shape");
 }
  var metal_product_non_dyor = localStorage.getItem("metal_name_nondyor");
  if(metal_product_non_dyor != null){
 metal_product11 = metal_product_non_dyor.split(',')[0];
 metal_product_handle1 = metal_product_non_dyor.split(',')[1]
 if(metal_product11 != null || metal_product11 != undefined){
  if(window.location.href.indexOf(metal_product_handle1) <0){
  localStorage.removeItem("metal_name_nondyor");
  }
 }
 }else{
   localStorage.removeItem("metal_name_nondyor");
 }
  if(get_web_url.indexOf('collections')>-1){
  $(document).on('click','.disclosure-has-popup[data-shape="shape"] .cstm_jtpl.list-menu__item,.mobile-facets__details[data-shape="shape"] li.custom_mob',function(){
   var current_selected_val = $(this).attr('val');
   var diamond_img =  getDiamondLinesImgTableResults1(current_selected_val)
   var wizardInfo_1  = JSON.parse(localStorage.getItem("wizardInfo"));
   if(wizardInfo_1 != null){
   new_wizardInfo_1 = wizardInfo_1['stone_shape']=current_selected_val;
   new_wizardInfo_1= wizardInfo_1['stone_image_url']=diamond_img;
    wizardInfo_1 = JSON.stringify(wizardInfo_1);
    localStorage.setItem("wizardInfo", wizardInfo_1);
   }else{
       localStorage.setItem("diamon_shape", current_selected_val);
   }
    
});
  }

  
 $(document).on('click','.collection-engagement-ring-settings-shape .featured-collection__product',function(){
  
    var pro_handlee = $(this).attr('data-product-handle');
    var metal_shapee = $(this).find('.jtpl_selected.dyor_loop_img').attr('data-shapee');
    var metal_color = $(this).find('.jtpl-variant-img.jtpl_selected').attr('alt');
    if(metal_shapee != ''){
       metal_shape1 =`${metal_shapee},${pro_handlee}`; 
       localStorage.setItem("diamon_shape", metal_shape1);
   } 
   if(metal_color != ''){
       metal_color =`${metal_color},${pro_handlee}`; 
       localStorage.setItem("metal_name", metal_color);
   } 
})
  
 $(document).on('click','.collection-engagement-ring-settings-shape .grid__item_shape',function(){
   
     var pro_handlee = $(this).find('.main_slider_image:first').attr('data-product-handle');
    var metal_shapee = $(this).find('.jtpl_selected.dyor_loop_img').attr('data-shapee');
    metal_shape1 =`${metal_shapee},${pro_handlee}`; 
   localStorage.setItem("diamon_shape", metal_shape1);
})

 $(document).on('click','.collection-studs .grid_slide_gem',function(){
  
    var pro_handlee = $(this).attr('data-handle');
    var metal_color = $(this).find('.jtpl-variant-img.jtpl_selected').attr('alt');
  
   if(metal_color != ''){
       metal_color =`${metal_color},${pro_handlee}`; 
       localStorage.setItem("metal_name_nondyor", metal_color);
   } 
})

  
  
function getDiamondLinesImgTableResults1(shape) {
    let shapesrc;

    switch (shape) {
        case "Round":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-round.png?v=1681486955";
            break;
        case "Radiant":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-radiant.png?v=1681486955";
            break;
        case "Princess":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-princess.png?v=1681486955";
            break;
        case "Pear":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-pear.png?v=1681486486";
            break;
        case "Oval":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-oval.png?v=1681486978";
            break;
        case "Marquise":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-marquise.png?v=1681486978";
            break;
        case "Heart":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-heart.png?v=1681486978";
            break;
        case "Emerald":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-emerald.png?v=1681486979";
            break;
        case "Cushion":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-cushion.png?v=1681486978";
            break;
        case "Asscher":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/diamond-lines-asscher.png?v=1660072977";
            break;
        default:
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-asscher.png?v=1681486978";
            break;
    }

    return shapesrc;
}

    $('a.menu-hijo.dyor_page').click(function(e){
    e.preventDefault();
  var dyor_page_link = $(this).attr('href');
  var complete_ring_step = localStorage.getItem("complete_ring_step");
  var diamond_step = localStorage.getItem("diamond_page_step");
  let infoRing = JSON.parse(localStorage.getItem('wizardInfo'));
       if(infoRing == null){
       localStorage.removeItem("complete_ring_step");
       localStorage.removeItem("diamond_page_step");
       window.location.href = `${dyor_page_link}`;
       }
    else if(infoRing.stone_id != null && infoRing.setting_product_id != null && infoRing.setting_product_id != '' && infoRing.stone_id != ''){
      window.location.href = `https://my-solitaire.myshopify.com/pages/complete-ring`;
     
    }else if(infoRing.stone_id != null && infoRing.stone_id != ''){
       let diamond_id = infoRing.stone_id;
        window.location.href =  `https://my-solitaire.myshopify.com/pages/diamond-detail?did=${diamond_id}`
        
    }else{
       window.location.href = `${dyor_page_link}`;
     }
})
   $(document).on('click','.filter-name-metal li,.mobile-facets__details[data-shape="metal"] li',function(e){
    e.preventDefault();

   var filter_type = $(this).find('input').attr('name');  
    var filter_val = $(this).find('input').attr('value');
    filter_val = filter_val.replace(' ','+')
    var current_url = window.location.href;
    
    if(current_url.indexOf('filter.p.m.custom.metal')>-1){
    var url_part2 =  current_url.split('filter.p.m.custom.metal=')[1];
        if(url_part2.indexOf('&')>-1){
          var metal_parameter = url_part2.split('&')[0];
          
        }else{
          var metal_parameter = url_part2;
        }
        window.location.href=window.location.href.replaceAll(metal_parameter, filter_val);
    }else{
       if(window.location.href.indexOf('?')>-1){
       window.location.href=window.location.href+'&'+filter_type+'='+filter_val;
      }else{
         window.location.href=window.location.href+'?'+filter_type+'='+filter_val;
      }
    }
})
  
if(get_web_url.indexOf('dyor-diamond-settings')>-1 || get_web_url.indexOf('necklaces-and-pendants')>-1 || get_web_url.indexOf('engagement-ring-settings-shape')>-1 || get_web_url.indexOf('engagement-ring-settings-with-gemstone')>-1){
    var wizardInfo_1  = JSON.parse(localStorage.getItem("wizardInfo"));
    if(get_web_url.indexOf('dyor-diamond-settings')>-1  || get_web_url.indexOf('engagement-ring-settings-shape')>-1 && wizardInfo_1 != null){
    if(wizardInfo_1.stone_id != null && wizardInfo_1.stone_shape != null){
      $('.disclosure-has-popup[data-shape="shape"],.mobile-facets__details[data-shape="shape"], .mobile-facets__main  [data-shape="shape"]').hide();
     }
    }
   var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo')); 
if(wizardInfo != null && get_web_url.indexOf('dyor-diamond-settings')>-1){
if(wizardInfo.stone_id != null && window.location.href.indexOf('dyo_carat_')<0 &&  window.location.href.indexOf('dyo_shape')>-1){
    $('.collection-dyor-diamond-settings .product-grid-container').html('');
    $('.product-grid-container').html(`<div class="onlyMobile">
<div class="collection collection--empty page-width" id="product-grid" data-id="template--15527639089288__product-grid">
            <div class="loading-overlay gradient"></div>
            <div class="title-wrapper center">
              <h2 class="title title--primary">
                No products found of this Diamond
                <br>
                Please change the Diamnod
              </h2>
            </div>
          </div></div>

     <div class="onlyDesk" id="jtpl_onlyDesk">
<div class="collection collection--empty page-width" id="product-grid" data-id="template--15527639089288__product-grid">
            <div class="loading-overlay gradient"></div>
            <div class="title-wrapper center">
              <h2 class="title title--primary">
                No products found of this Diamond
                <br>
                Please change the Diamnod
              </h2>
            </div>
          </div></div> `)
    $('details').remove();
   $('.newProductCount-top p').html('0 Engagement Ring Settings')
}
}
  $('.remove_filter_data').click(function(){
if(wizardInfo != null && get_web_url.indexOf('dyor-diamond-settings')>-1){
if(wizardInfo.stone_id != null && window.location.href.indexOf('dyo_carat_')<0 &&  window.location.href.indexOf('dyo_shape')>-1){
 localStorage.removeItem('wizardInfo'); 
}
}
 })
 $(document).on('click','.filter-name-shape li,.mobile-facets__details[data-shape="shape"] li',function(e){
    e.preventDefault();
    var filter_type = $(this).find('input').attr('name');  
    var filter_val = $(this).find('input').attr('value');
    filter_val = filter_val.replace(' ','+')
    var current_url = window.location.href;
    
    if(current_url.indexOf('filter.p.tag')>-1){
    var url_part2 =  current_url.split('filter.p.tag=')[1];
    if(url_part2.indexOf('&')>-1){
    var shape_parameter = url_part2.split('&')[0]; 
    }else{
    var shape_parameter = url_part2; 
    }
      window.location.href=window.location.href.replaceAll(shape_parameter, filter_val);  
    }else{
      if(window.location.href.indexOf('?')>-1){
       window.location.href=window.location.href+'&'+filter_type+'='+filter_val;
      }else{
         window.location.href=window.location.href+'?'+filter_type+'='+filter_val;
      }
    }
})

$('.mobile-facets__summary[data-shape="type"]').parent('details').hide();
$('details[data-shape="type"]').hide();
$('li.cstm_jtpl.list-menu__item.facets__item').each(function () {
    var get_val = $(this).attr('val');

    if(get_val.includes('_') || get_val == 'Test' || get_val == '14k silver' ){
    $(this).hide();
    }else{
     $(this).show();
    }
   
});
 
  if(window.location.href.indexOf('dyor-diamond-settings/dyo_shape') >-1 || get_web_url.indexOf('+dyo_shape') >-1 ){
  $("details.disclosure-has-popup.facets__disclosure.js-filter[data-index='2']").hide();
  $('details.mobile-facets__details.js-filter[data-index="mobile-2"]').hide(); 
  }
// filters in mobile  start


$('li.custom_mob.mobile-facets__item.list-menu__item').each(function () {
    var get_val = $(this).attr('val');
   
    if(get_val.includes('_') || get_val == 'test' || get_val == '14k Silver' ||  get_val == 'Hidden Halo' || get_val == 'insane pick' ){
    $(this).hide();
    }else{
        $(this).show();
    }
   
});
}
mobileOnlySlider(".jtplcontentSubCdesk", false, false, 767);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
     slidesToShow: 3,
     slidesToScroll: 1,
    touchMove:true,
     infinite: false,
    easing: 'linear',
    cssEase: 'linear',
    arrows: $arrows,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick"
      }
    ]
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}
       

$(document).on('click', '.sticky-button', function(event) {
setTimeout(function(){
$(".jtpl-custom-cart-drawer").load(location.href + " .cart-count-bubble");
  $(".jtpl-custom-cart-drawer").load(location.href + " .drawer");
    $(".jtpl-custom-cart-drawer-1").load(location.href + " .cart-count-bubble");
  $(".jtpl-custom-cart-drawer-1").load(location.href + " .drawer");
 },2000);
});
                          

$(document).on('click', '.cart-remove-button', function(event) {
  $(".jtpl-custom-cart-drawer-1").load(location.href + " .cart-count-bubble");
  $(".jtpl-custom-cart-drawer").load(location.href + " .cart-count-bubble");
  $(".jtpl-custom-cart-drawer").load(location.href + " .drawer");
  $(".jtpl-custom-cart-drawer-1").load(location.href + " .drawer");
});
                
$(document).on('click', '.cart-remove-button', function(event) {
var product_id = $(this).parents('.cart-item').attr('data-key');
var ring_gemstone = $(this).parents('.cart-item[data_ring_with_gemstone="true"]').length;
var engrave_product = $(this).parents('.cart-item[data-engrave_product="true"]').length;  
  if(ring_gemstone > 0){
   var random = $(this).parents('.cart-item[data_ring_with_gemstone="true"]').attr('data-rendom_no');
  }
  if(engrave_product > 0){
  var random = $(this).parents('.cart-item[data-engrave_product="true"]').attr('data-rendom_no');
 }
 $.ajax({
    type: "POST",
    url: '/cart/change.js',
    data: { 
      quantity:0, 
      id: product_id,
    },
    success: function(item){
      var item = JSON.parse(item)
      if(ring_gemstone > 0 || engrave_product > 0){
      for(var i = 0; i<item.items.length; i++){
      if(item.items[i].properties['_rendom_no'] == random){
      var stone_id = item.items[i].key
      $.ajax({
        type: "POST",
        url: '/cart/change.js',
          async:'false',
          data: { 
          quantity:0, 
          id: stone_id,
          },
          success: function(data){
          location.reload();
          $(".jtpl-custom-cart-drawer").load(location.href + " .drawer");
          $(".jtpl-custom-cart-drawer-1").load(location.href + " .drawer");
          $(".jtpl-custom-cart-drawer").load(location.href + " .cart-count-bubble");
       }
       })
     }
     }
      } else{
      location.reload();
      $(".jtpl-custom-cart-drawer").load(location.href + " .drawer");
      $(".jtpl-custom-cart-drawer-1").load(location.href + " .drawer");
      $(".jtpl-custom-cart-drawer").load(location.href + " .cart-count-bubble");
      }
   },
  });                  
 });
   /*** announcement bar minicartdrawer js end  *******/

  
/*** SHop a look  *******/
  
$(document).on('mouseover mouseleave', '.jtpl_collection_prd_pop_up', function(e) {   
  if(e.type === 'mouseover') {
     $(this).addClass("Shop_img_btn_hover");
  }else {
   $(this).removeClass("Shop_img_btn_hover");
  }
});

  
  $("div#shop_the_image_jtpl_banner1").click(function(){
  
     
     $("body").addClass('jtpl-col-prod');
     $(".contentFoto.jtpl_collection_prd_pop_up").addClass("show_pop_shop_look_jtpl1");
});
  $(document).on('click','.jtpl_collection_prd_pop_up img',function(){
     $('.jtpl_collection_prd_pop_up').removeClass('show_pop_shop_look_jtpl1 show_pop_shop_look_jtpl2 show_pop_shop_look_jtpl3')
   if($(this).parents('.jtpl_collection_prd_pop_up').find('#shop_the_image_jtpl_banner2').length >0){
     $(this).parents('.jtpl_collection_prd_pop_up').addClass("show_pop_shop_look_jtpl2");
     $(".contentFoto.jtpl_collection_prd_pop_up .featured-collection__product .card__media img").each(function(){
     var img_src = $(this).attr('data-srcset');
     $(this).attr('src',img_src);
      })
    }else if($(this).parents('.jtpl_collection_prd_pop_up').find('#shop_the_image_jtpl_banner1').length >0){
     $(this).parents('.jtpl_collection_prd_pop_up').addClass("show_pop_shop_look_jtpl1");
     $(".contentFoto.jtpl_collection_prd_pop_up .featured-collection__product .card__media img").each(function(){
     var img_src = $(this).attr('data-srcset');
     $(this).attr('src',img_src);
     })
    }
 
 
 })
  $(document).on('click','span.Shop_lk_pop_close',function () {
     $("body").removeClass('jtpl-col-prod');
     $('.contentFoto.jtpl_collection_prd_pop_up').removeClass('show_pop_shop_look_jtpl1 show_pop_shop_look_jtpl2 show_pop_shop_look_jtpl3');
});


//     $("div#shop_the_image_jtpl_banner2").click(function(){
//   $(".contentFoto.jtpl_collection_prd_pop_up").addClass("show_pop_shop_look_jtpl2 ");
// });
//   $('span.Shop_lk_pop_close svg').click(function () {
//     $('.contentFoto.jtpl_collection_prd_pop_up').removeClass('show_pop_shop_look_jtpl2');
// });


//   $("div#shop_the_image_jtpl_banner3").click(function(){
//   $(".contentFoto.jtpl_collection_prd_pop_up").addClass("show_pop_shop_look_jtpl3");
// });
//   $('span.Shop_lk_pop_close svg').click(function () {
//     $('.contentFoto.jtpl_collection_prd_pop_up').removeClass('show_pop_shop_look_jtpl3');
// });
  
  
  $(".shop-the-image-button").click(function(){
  $("body").addClass('jtpl-col-prod');
});
  $('span.Shop_lk_pop_close svg').click(function () {
    $("body").removeClass('jtpl-col-prod');
});
});


$(document).ready(function() {
 
   setTimeout(function(){  
var getDataoptionVal = $('#variant_id').text();


$('.cstm-varaint-specific-jtpl').each(function () {
var getDatatitle =   $(this).attr('data-title');

if(getDataoptionVal == getDatatitle){
$(this).show();
}else{
$(this).hide();
}

});
 },100)
  // variant specific price hide
var text = $('.jtpl-tab-name').last().text();

$('.jtpl-icon-img').click(function() {
$(".raw_tab_1").addClass("active");
$(".rw_mt_1").css("display", "block");
var getDataoptionVal = $('#variant_id').text();

$('.cstm-varaint-specific-jtpl').each(function () {
var getDatatitle =   $(this).attr('data-title');

if(getDataoptionVal == getDatatitle){
$(this).show();
}else{
$(this).hide();
}

});
var _this = this;
 var tab_name = $(this).parents('.tw-border-b').find('.jtpl-tab-name').text();



setTimeout(function() {
 if ($("img").hasClass("my-class")) {
  
    $('.my-class2').hide();
  } else{
 
   if(tab_name == 'Metal:'){

 setTimeout(function(){    
        var metal = $(_this).parents('.tw-border-b').find('#metal_name_jtpl').text().split(" ").join("-");
         $('.jtpl-skintone-image .hand_ring_overlay').hide();
         $('.jtpl-skintone-image .hand_ring_overlay[data-handle="'+metal+'"]').show();
    },200)
    }
  }
 }, 100);
 });
});
  /*** search icon popup js start  *******/

$(document).on('click', '.cstm-jtpl-toggle', function(event) {
setTimeout(function(){    
   $('.cstm-predictive-search #Search-In-Template').trigger('focus');
 },700)
  $('.jtpl_overlay').addClass('new_jtpl_poup');
  
  // event.preventDefault();
  var target = $(this).data('target');
  $('.popup').toggleClass('hide');
$('body').toggleClass('search_active');
});


// $(document).on('click', '.cstm-jtpl-toggle', function(event) {
// event.preventDefault();
//    $('.cstm-predictive-search #Search-In-Template').trigger('focus');
//   $('.jtpl_overlay').addClass('new_jtpl_poup');
//   var target = $(this).data('target');
//   $('.popup').toggleClass('hide');
// $('body').toggleClass('search_active');
// });


  /*** search icon popup js end  *******/

  /*** search onscroll to top  *******/
$(window). scroll(function(){
  if ($(this). scrollTop() > 0) {  
$('.popup').addClass('newClass');
} else {
 $('.popup').removeClass('newClass');
 }
});
  /*** search onscroll to top  *******/

/*** search onclick outside popup close  *******/
$(document).on('click', '.new_jtpl_poup', function(event) {
$('#myPopup').addClass('hide');
 $('#myPopup').removeClass('show');
$('.jtpl_overlay').removeClass('new_jtpl_poup');
$('body').removeClass('search_active');
});
/*** search onclick outside popup close  *******/


$(document).ready(function(){
 


jQuery.fn.scrollTo = function(elem, speed) { 
    $(this).animate({
        scrollTop:  $(this).scrollTop() - $(this).offset().top + $(elem).offset().top-40 
    }, speed == undefined ? 1000 : speed); 
    return this; 
};
  

  
 /*** search height adjust acc to result  *******/ 
   $("#Search-In-Template").keyup(function(){
     setTimeout( function(){
     var search_height =  $("#predictive-search-results-groups-wrapper").height();
     var newHeight = search_height+80;
     if(newHeight < 400){
       newHeight = 401;
     }
     $("#myPopup").css("min-height",newHeight);
     }, 800)
  });
 
 /*** search height adjust acc to result  *******/ 
$("#hum_imp_cst").click(function(){
  $(".mb_link_1").hide();
  $(".mb_link_2").hide();
  $(".mb_link_3").show();
});
  
$("#co2_cstm").click(function(){
  $(".mb_link_1").hide();
  $(".mb_link_2").show();
  $(".mb_link_3").hide();
});
  
$("#trac_cst_jtpl").click(function(){
  $(".mb_link_1").show();
  $(".mb_link_2").hide();
  $(".mb_link_3").hide();

 
  
});  


$("#creativity_link").click(function(){
  $(".jtpl_Progress_bar_main_link1").show();
  $(".jtpl_Progress_bar_main_link2").hide();
  $(".jtpl_Progress_bar_main_link3").hide();
});

 

  $("#impact_tab").click(function(){
  $(".jtpl_Progress_bar_main_link1").hide();
  $(".jtpl_Progress_bar_main_link2").hide();
  $(".jtpl_Progress_bar_main_link3").show();
   $("#carbon_tab_1").addClass("active");
  $("#Carbon").css("display", "block");
});

  
  
  
  /*** popup search icon focus js start  *******/
  $(".search-icon").click(function () {
    setTimeout(function(){
      document.getElementById('Search-In-Template').focus()
     //$(this).prev(".search__input").focus();
    },100)
    });
  /***  popup search icon focus js end *******/


  
/***  order details tabs js start START *******/
    $('.jtpl_Order_tabs_main .tabs li a').click(function(e){
    e.preventDefault();
    $(this).addClass('active');
    $('.jtpl_Order_tabs_main .tabs li a').not($(this)).removeClass('active');
   var data_map = $(this).attr('href');
   $('.tabs_content').hide();
  $(data_map).show();
    
})
/***  order details tabs js start end *******/

/***  product details mobile accordian js start  *******/
  const accordionTitles = document.querySelectorAll(".accordionTitle");
accordionTitles.forEach((accordionTitle) => {
	accordionTitle.addEventListener("click", () => {
		if (accordionTitle.classList.contains("is-open")) {
			accordionTitle.classList.remove("is-open");
		} else {
			const accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
			accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
				accordionTitleWithIsOpen.classList.remove("is-open");
			});
			accordionTitle.classList.add("is-open");
		}
	});
});
  /***  product details mobile accordian js end  *******/
   /***  order details section colapsible tab js start  *******/
	 $(document).on('click',".accordion-item-header",function(){
    $(this).toggleClass('active');
    $(this).parents('.accordion-item').find('.accordion-item-body').slideToggle();  
    })
   /***  order details section colapsible tab js end  *******/

  

  
});



